(function () {
  function rootUrl() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  }

  function bundleSections() {
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
    return sections;
  }

  async function refreshCartFromPayload(payload, baseEvent) {
    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart') {
      window.location.reload();
      return;
    }

    var cart = await (await fetch(rootUrl() + 'cart.js')).json();
    if (payload && payload.sections) cart.sections = payload.sections;
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: baseEvent || 'cart:change', onSuccessDo: 'force_open_drawer', cart: cart }
    }));
  }

  function setProductShareStatus(trigger, message) {
    var utilities = trigger && trigger.closest('.bup-product-utilities');
    var status = utilities && utilities.querySelector('[data-bup-share-status]');
    if (!status) return;

    status.textContent = message;
    window.setTimeout(function () {
      if (status.textContent === message) status.textContent = '';
    }, 2200);
  }

  async function copyProductUrl(url) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url);
      return;
    }

    var textarea = document.createElement('textarea');
    textarea.value = url;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    var copied = document.execCommand('copy');
    textarea.remove();
    if (!copied) throw new Error('Copy command failed');
  }

  async function shareProduct(trigger) {
    var title = trigger.getAttribute('data-bup-share-title') || document.title;
    var url = trigger.getAttribute('data-bup-share-url') || window.location.href;

    if (navigator.share) {
      try {
        await navigator.share({ title: title, url: url });
        return;
      } catch (error) {
        if (error && error.name === 'AbortError') return;
      }
    }

    try {
      await copyProductUrl(url);
      setProductShareStatus(trigger, 'Bağlantı kopyalandı');
    } catch (error) {
      setProductShareStatus(trigger, 'Bağlantı kopyalanamadı');
    }
  }

  async function addVariant(variantId, button, properties) {
    if (!variantId) return;
    var oldText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Ekleniyor...';
    }

    var sections = bundleSections();
    var body = { id: Number(variantId), quantity: 1, sections: sections.join(','), sections_url: window.location.pathname };

    if (properties && Object.keys(properties).length > 0) {
      body.properties = properties;
    }

    var response = await fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
    var payload = await response.json();

    if (!response.ok) {
      if (button) button.textContent = payload.description || 'Eklenemedi';
      window.setTimeout(function () {
        if (button) {
          button.disabled = false;
          button.textContent = oldText;
        }
      }, 1600);
      return;
    }

    await refreshCartFromPayload(payload, 'variant:add');
    if (button) {
      button.disabled = false;
      button.textContent = oldText;
    }
  }

  function getKombinVariant(item) {
    var select = item && item.querySelector('[data-bup-kombin-variant]');
    var option = select && select.options[select.selectedIndex];

    if (!select || !option) return null;

    return {
      id: Number(option.value),
      price: Number(option.getAttribute('data-bup-kombin-price') || 0),
      compareAtPrice: Number(option.getAttribute('data-bup-kombin-compare-at-price') || 0),
      available: option.getAttribute('data-bup-kombin-available') !== 'false'
    };
  }

  function getKombinQuantity(item) {
    var value = item && item.querySelector('[data-bup-kombin-quantity-value]');
    return Math.max(1, Number(value && value.textContent) || 1);
  }

  function setKombinStatus(bundle, message, isError) {
    var status = bundle && bundle.querySelector('[data-bup-kombin-status]');
    if (!status) return;

    status.hidden = !message;
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  function updateKombinItem(item) {
    if (!item) return null;

    var variant = getKombinVariant(item);
    var checkbox = item.querySelector('[data-bup-kombin-check]');
    var price = item.querySelector('[data-bup-kombin-item-price]');
    var compareAtPrice = item.querySelector('[data-bup-kombin-item-compare]');

    if (!variant || !checkbox) return null;

    var isVisualOnly = variant.price <= 0;

    checkbox.disabled = !variant.available || isVisualOnly;
    if (!variant.available || isVisualOnly) checkbox.checked = false;
    item.classList.toggle('is-unavailable', !variant.available || isVisualOnly);
    item.classList.toggle('is-selected', checkbox.checked && variant.available && !isVisualOnly);

    if (price) price.textContent = formatMoney(variant.price);
    if (compareAtPrice) {
      compareAtPrice.hidden = !(variant.compareAtPrice > variant.price);
      if (!compareAtPrice.hidden) compareAtPrice.textContent = formatMoney(variant.compareAtPrice);
    }

    return variant;
  }

  function getSelectedKombinItems(bundle) {
    return Array.from(bundle.querySelectorAll('[data-bup-kombin-item]')).reduce(function (items, item) {
      var checkbox = item.querySelector('[data-bup-kombin-check]');
      var variant = getKombinVariant(item);

      if (checkbox && checkbox.checked && !checkbox.disabled && variant && variant.available && variant.price > 0 && variant.id) {
        items.push({
          id: variant.id,
          quantity: getKombinQuantity(item),
          productId: item.getAttribute('data-bup-kombin-product-id') || ''
        });
      }

      return items;
    }, []);
  }

  function updateKombinBundle(bundle) {
    if (!bundle) return;

    var total = 0;
    bundle.querySelectorAll('[data-bup-kombin-item]').forEach(function (item) {
      var variant = updateKombinItem(item);
      var checkbox = item.querySelector('[data-bup-kombin-check]');
      if (variant && checkbox && checkbox.checked && !checkbox.disabled && variant.available && variant.price > 0) {
        total += variant.price * getKombinQuantity(item);
      }
    });

    var totalElement = bundle.querySelector('[data-bup-kombin-total]');
    if (totalElement) totalElement.textContent = formatMoney(total);

    var addButton = bundle.querySelector('[data-bup-kombin-add]');
    if (addButton && !addButton.classList.contains('is-loading')) {
      addButton.disabled = getSelectedKombinItems(bundle).length === 0;
    }
  }

  function startKombinTimer(bundle) {
    var timer = bundle && bundle.querySelector('[data-bup-kombin-timer]');
    if (!timer || bundle.dataset.bupKombinTimerBound === 'true') return;

    bundle.dataset.bupKombinTimerBound = 'true';
    var duration = Math.max(1, Number(bundle.getAttribute('data-bup-kombin-timer-hours') || 6)) * 60 * 60 * 1000;
    var storageKey = 'bup-kombin-timer-' + (bundle.getAttribute('data-bup-kombin-id') || 'default');
    var target = 0;

    try {
      target = Number(window.localStorage.getItem(storageKey)) || 0;
    } catch (error) {
      target = 0;
    }

    function persistTarget() {
      try {
        window.localStorage.setItem(storageKey, String(target));
      } catch (error) {}
    }

    function tick() {
      var now = Date.now();
      if (target <= now) {
        target = now + duration;
        persistTarget();
      }

      var remaining = Math.max(0, target - now);
      var hours = Math.floor(remaining / 3600000);
      var minutes = Math.floor((remaining % 3600000) / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);
      var value = timer.querySelector('[data-bup-kombin-timer-value]');

      if (value) {
        value.textContent = [hours, minutes, seconds].map(function (part) {
          return String(part).padStart(2, '0');
        }).join(':');
      }
    }

    tick();
    bundle._bupKombinTimer = window.setInterval(tick, 1000);
  }

  function hydrateKombinBundles(scope) {
    var bundles = [];
    if (scope && scope.matches && scope.matches('[data-bup-kombin-bundle]')) bundles.push(scope);
    if (scope && scope.querySelectorAll) bundles = bundles.concat(Array.from(scope.querySelectorAll('[data-bup-kombin-bundle]')));

    bundles.forEach(function (bundle) {
      updateKombinBundle(bundle);
      startKombinTimer(bundle);
    });
  }

  async function addKombinBundle(button) {
    var bundle = button && button.closest('[data-bup-kombin-bundle]');
    if (!bundle) return;

    var selectedItems = getSelectedKombinItems(bundle);
    if (!selectedItems.length) {
      setKombinStatus(bundle, 'Sepete eklemek için en az bir ürün seçin.', true);
      return;
    }

    var originalText = button.textContent;
    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'Ekleniyor...';
    setKombinStatus(bundle, '');

    var bundleTitle = bundle.getAttribute('data-bup-kombin-title') || 'Kombin Fırsatı';
    var bundleId = bundle.getAttribute('data-bup-kombin-id') || '';
    var sections = bundleSections();

    try {
      var response = await fetch(rootUrl() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: selectedItems.map(function (item) {
            return {
              id: item.id,
              quantity: item.quantity,
              properties: {
                _bup_kombin: bundleTitle,
                _bup_kombin_id: bundleId,
                _bup_kombin_product_id: item.productId
              }
            };
          }),
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      });
      var payload = await response.json();

      if (!response.ok) {
        setKombinStatus(bundle, payload.description || 'Kombin sepete eklenemedi.', true);
        return;
      }

      await refreshCartFromPayload(payload, 'kombin:add');
    } catch (error) {
      setKombinStatus(bundle, 'Bağlantı kurulamadı. Lütfen tekrar deneyin.', true);
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.textContent = originalText;
      updateKombinBundle(bundle);
    }
  }

  async function removeVariant(variantId) {
    var cart = await (await fetch(rootUrl() + 'cart.js')).json();
    var line = cart.items.find(function (item) { return String(item.variant_id) === String(variantId); });
    if (!line) return;

    var sections = bundleSections();
    var response = await fetch(rootUrl() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0, sections: sections.join(','), sections_url: window.location.pathname })
    });
    var payload = await response.json();
    await refreshCartFromPayload(payload, 'line-item:change');
  }

  async function clearCart(button) {
    if (!button || button.disabled) return;

    var originalText = button.textContent.trim();
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Sepet boşaltılıyor...';

    try {
      var sections = bundleSections();
      var response = await fetch(rootUrl() + 'cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ sections: sections.join(','), sections_url: window.location.pathname })
      });
      var payload = {};

      try {
        payload = await response.json();
      } catch (error) {
        payload = {};
      }

      if (!response.ok) {
        throw new Error(payload.description || 'Sepet boşaltılamadı.');
      }

      await refreshCartFromPayload(payload, 'cart:clear');

      if (button.isConnected) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = originalText;
      }
    } catch (error) {
      if (!button.isConnected) return;

      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = 'Tekrar deneyin';

      window.setTimeout(function () {
        if (!button.isConnected) return;
        button.textContent = originalText;
      }, 1800);
    }
  }

  function normalizeVideoEmbeds(scope) {
    (scope || document).querySelectorAll('[data-bup-video-modal] iframe').forEach(function (iframe) {
      iframe.setAttribute('allowfullscreen', 'allowfullscreen');
      iframe.setAttribute('webkitallowfullscreen', 'webkitallowfullscreen');
      iframe.setAttribute('mozallowfullscreen', 'mozallowfullscreen');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen');
      if (!iframe.getAttribute('title')) iframe.setAttribute('title', 'Ürün videosu');
    });
    (scope || document).querySelectorAll('[data-bup-video-modal] video').forEach(function (video) {
      video.setAttribute('controls', 'controls');
      video.setAttribute('playsinline', 'playsinline');
      video.setAttribute('webkit-playsinline', 'webkit-playsinline');
      video.style.objectFit = 'contain';
    });
  }

  function pauseVideos(modal) {
    if (!modal) return;
    modal.querySelectorAll('video').forEach(function (video) { try { video.pause(); } catch (e) {} });
    modal.querySelectorAll('iframe').forEach(function (iframe) {
      var src = iframe.getAttribute('src');
      if (src) iframe.setAttribute('src', src);
    });
  }

  function openVideo(modal) {
    if (!modal) return;
    normalizeVideoEmbeds(modal);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bup-video-modal-open');
    document.body.classList.add('bup-video-modal-open');
    var video = modal.querySelector('video');
    if (video) { try { video.play(); } catch (e) {} }
  }

  function closeVideo(modal) {
    if (!modal) return;
    pauseVideos(modal);
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bup-video-modal-open');
    document.body.classList.remove('bup-video-modal-open');
  }

  function keepProductVideoGalleryImagesVisible(gallery) {
    if (!gallery) return;

    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    // A desktop grid is not a carousel. Keep its natural height after a
    // product re-render so every non-video image remains in the document flow.
    if (gallery.hasAttribute('data-bup-grid-gallery')) {
      carousel.removeAttribute('adaptive-height');
      carousel.style.removeProperty('max-height');
    }

    carousel.querySelectorAll(':scope > .product-gallery__media').forEach(function (media) {
      if (media.getAttribute('data-media-type') !== 'video' && media.getAttribute('data-media-type') !== 'external_video') {
        media.removeAttribute('hidden');
      }
    });

    gallery.querySelectorAll('product-gallery-navigation, carousel-navigation').forEach(function (navigation) {
      if (navigation.getAttribute('aria-controls') !== carousel.id) return;
      navigation.querySelectorAll('button').forEach(function (button) {
        button.removeAttribute('hidden');
      });
    });
  }

  function bindProductVideoGallery(gallery) {
    if (!gallery || gallery.dataset.bupVideoGalleryBound === 'true') return;

    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    gallery.dataset.bupVideoGalleryBound = 'true';
    keepProductVideoGalleryImagesVisible(gallery);

    carousel.addEventListener('carousel:filter', function () {
      window.requestAnimationFrame(function () {
        keepProductVideoGalleryImagesVisible(gallery);
      });
    });

    new MutationObserver(function () {
      keepProductVideoGalleryImagesVisible(gallery);
    }).observe(carousel, { attributes: true, attributeFilter: ['hidden'], childList: true });
  }

  function bindProductVideoGalleries(scope) {
    if (!scope) return;

    if (scope.matches && scope.matches('product-gallery[data-bup-video-gallery]')) {
      bindProductVideoGallery(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('product-gallery[data-bup-video-gallery]').forEach(bindProductVideoGallery);
    }
  }

  function bindProductGalleryZoom(gallery) {
    if (!gallery || gallery.dataset.bupGalleryZoomBound === 'true' || !gallery.hasAttribute('allow-zoom')) return;

    var carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    gallery.dataset.bupGalleryZoomBound = 'true';
    var startPoint = null;

    function isPhoneViewport() {
      return window.matchMedia && window.matchMedia('(max-width: 699px)').matches;
    }

    carousel.addEventListener('pointerdown', function (event) {
      if (!isPhoneViewport() || event.pointerType === 'mouse' || event.button !== 0 || event.target.tagName !== 'IMG') return;

      startPoint = { id: event.pointerId, x: event.clientX, y: event.clientY };
    });

    carousel.addEventListener('pointermove', function (event) {
      if (!startPoint || startPoint.id !== event.pointerId) return;

      if (Math.abs(event.clientX - startPoint.x) > 8 || Math.abs(event.clientY - startPoint.y) > 8) {
        startPoint = null;
      }
    });

    carousel.addEventListener('pointercancel', function () {
      startPoint = null;
    });

    carousel.addEventListener('pointerup', function (event) {
      if (!startPoint || startPoint.id !== event.pointerId) return;

      startPoint = null;
      if (!isPhoneViewport() || event.target.tagName !== 'IMG') return;

      var media = event.target.closest('.product-gallery__media');
      if (!media || media.getAttribute('data-media-type') !== 'image') return;

      var imageCells = carousel.cells ? carousel.cells.filter(function (cell) {
        return cell.getAttribute('data-media-type') === 'image';
      }) : Array.prototype.slice.call(carousel.querySelectorAll(':scope > .product-gallery__media[data-media-type="image"]'));
      var index = imageCells.indexOf(media);

      if (index >= 0) {
        gallery.dispatchEvent(new CustomEvent('lightbox:open', { bubbles: true, detail: { index: index } }));
      }
    });
  }

  function bindProductGalleryZooms(scope) {
    if (!scope) return;

    if (scope.matches && scope.matches('product-gallery[allow-zoom]')) {
      bindProductGalleryZoom(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('product-gallery[allow-zoom]').forEach(bindProductGalleryZoom);
    }
  }

  function setWeeklyOfferState(root, open) {
    if (!root) return;
    root.classList.toggle('is-open', open);
    var drawer = root.querySelector('.bup-weekly-offer__drawer');
    var trigger = root.querySelector('[data-bup-weekly-toggle]');
    if (drawer) drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function syncMobileNavigationState() {
    var navigationOpen = Array.prototype.some.call(document.querySelectorAll('.bup-live-mobile-sidebar'), function (drawer) {
      return drawer.hasAttribute('open');
    });

    document.documentElement.classList.toggle('bup-navigation-drawer-open', navigationOpen);

    if (navigationOpen) {
      document.querySelectorAll('[data-bup-weekly-offer].is-open').forEach(function (offer) {
        setWeeklyOfferState(offer, false);
      });
    }
  }

  function initializeLiveMobileNavigation(scope) {
    var root = scope && scope.nodeType === Node.ELEMENT_NODE ? scope : document;
    var drawers = [];

    if (root.matches && root.matches('.bup-live-mobile-sidebar')) drawers.push(root);
    if (root.querySelectorAll) drawers = drawers.concat(Array.prototype.slice.call(root.querySelectorAll('.bup-live-mobile-sidebar')));

    drawers.forEach(function (drawer) {
      if (drawer.dataset.bupMobileNavigationBound === 'true') return;

      drawer.dataset.bupMobileNavigationBound = 'true';
      drawer.addEventListener('dialog:before-show', syncMobileNavigationState);
      drawer.addEventListener('dialog:after-hide', syncMobileNavigationState);
    });

    syncMobileNavigationState();
  }

  function syncCartDrawerState() {
    var cartDrawerOpen = Array.prototype.some.call(document.querySelectorAll('cart-drawer'), function (drawer) {
      return drawer.hasAttribute('open');
    });

    document.documentElement.classList.toggle('bup-cart-drawer-open', cartDrawerOpen);

    if (cartDrawerOpen) {
      document.querySelectorAll('[data-bup-weekly-offer].is-open').forEach(function (offer) {
        setWeeklyOfferState(offer, false);
      });
    }
  }

  function initializeCartDrawerState(scope) {
    var root = scope && scope.nodeType === Node.ELEMENT_NODE ? scope : document;
    var drawers = [];

    if (root.matches && root.matches('cart-drawer')) drawers.push(root);
    if (root.querySelectorAll) drawers = drawers.concat(Array.prototype.slice.call(root.querySelectorAll('cart-drawer')));

    drawers.forEach(function (drawer) {
      if (drawer.dataset.bupCartDrawerStateBound === 'true') return;

      drawer.dataset.bupCartDrawerStateBound = 'true';
      drawer.addEventListener('dialog:before-show', syncCartDrawerState);
      drawer.addEventListener('dialog:after-hide', syncCartDrawerState);
    });

    syncCartDrawerState();
  }

  function copyCampaignCode(button) {
    var code = button && button.getAttribute('data-bup-campaign-copy');
    if (!code) return;

    var markCopied = function () {
      button.classList.add('is-copied');
      window.clearTimeout(button.bupCampaignCopiedTimer);
      button.bupCampaignCopiedTimer = window.setTimeout(function () {
        button.classList.remove('is-copied');
      }, 1200);
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(markCopied).catch(markCopied);
    } else {
      var input = document.createElement('input');
      input.value = code;
      input.setAttribute('readonly', 'readonly');
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      try { document.execCommand('copy'); } catch (e) {}
      input.remove();
      markCopied();
    }
  }

  function buildCampaignCodeButton(code) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'bup-campaign-offer__code';
    button.setAttribute('data-bup-campaign-copy', code);
    button.setAttribute('aria-label', code + ' indirim kodunu kopyala');
    button.textContent = code;
    return button;
  }

  function hydrateCampaignCodes(scope) {
    (scope || document).querySelectorAll('.bup-campaign-offer__line').forEach(function (line) {
      if (line.querySelector('[data-bup-campaign-copy]')) return;

      var text = line.textContent || '';
      var match = text.match(/\b(?=[A-Z0-9]*[A-Z])(?=[A-Z0-9]*\d)[A-Z0-9]{3,}\b/);
      if (!match) return;

      var code = match[0];
      var before = text.slice(0, match.index);
      var after = text.slice(match.index + code.length);
      line.textContent = '';
      line.append(document.createTextNode(before));
      line.append(buildCampaignCodeButton(code));
      line.append(document.createTextNode(after));
    });
  }

  function padTime(value) {
    return String(value).padStart(2, '0');
  }

  function getCampaignCycleDiff(now) {
    var nextBoundaryHour = now.getHours() < 12 ? 12 : 24;
    var nextBoundary = new Date(now.getFullYear(), now.getMonth(), now.getDate(), nextBoundaryHour, 0, 0, 0);
    return Math.max(0, nextBoundary.getTime() - now.getTime());
  }

  function updateCampaignCountdowns(scope) {
    var timers = (scope || document).querySelectorAll('[data-bup-campaign-countdown]');
    if (!timers.length) return false;

    var now = new Date();
    var nowTimestamp = now.getTime();
    var hasActiveTimer = false;

    timers.forEach(function (timer) {
      var expiresAt = (Number(timer.getAttribute('data-bup-campaign-countdown-expires-at')) || 0) * 1000;
      var diff = expiresAt > 0 ? expiresAt - nowTimestamp : getCampaignCycleDiff(now);

      if (diff <= 0) {
        var campaignOffer = timer.closest('[data-bup-campaign-offer]');
        if (campaignOffer) campaignOffer.hidden = true;
        return;
      }

      var hours = Math.floor(diff / 36e5);
      var minutes = Math.floor(diff % 36e5 / 6e4);
      var seconds = Math.floor(diff % 6e4 / 1000);
      var labelPrefix = timer.getAttribute('data-bup-campaign-countdown-label') || 'Kampanya bitimine';
      timer.textContent = labelPrefix + ' ' + padTime(hours) + ':' + padTime(minutes) + ':' + padTime(seconds);
      hasActiveTimer = true;
    });

    return hasActiveTimer;
  }

  var campaignCountdownInterval = null;
  function startCampaignCountdowns(scope) {
    if (!updateCampaignCountdowns(scope || document)) return;
    if (campaignCountdownInterval) return;
    campaignCountdownInterval = window.setInterval(function () {
      if (!updateCampaignCountdowns(document)) {
        window.clearInterval(campaignCountdownInterval);
        campaignCountdownInterval = null;
      }
    }, 1000);
  }

  function refreshProductAppMounts(scope) {
    var root = scope || document;
    var mounts = [];

    if (root.matches && root.matches('[data-bup-swatchsync], [data-bup-superdesk-rating]')) {
      mounts.push(root);
    }

    if (root.querySelectorAll) {
      mounts = mounts.concat(Array.prototype.slice.call(root.querySelectorAll('[data-bup-swatchsync], [data-bup-superdesk-rating]')));
    }

    if (!mounts.length) return;

    document.dispatchEvent(new CustomEvent('bup:product-apps:mount', { detail: { scope: root, mounts: Array.from(mounts) } }));

    [
      window.SwatchSynch,
      window.SwatchSync,
      window.swatchSynch,
      window.swatchSync,
      window.Superdesk,
      window.superdesk
    ].forEach(function (app) {
      if (!app) return;
      ['init', 'load', 'refresh', 'render', 'reload'].forEach(function (method) {
        if (typeof app[method] === 'function') {
          try { app[method](root); } catch (error) {}
        }
      });
    });
  }

  var superdeskRatingReadyPromise = null;
  var quickBuySuperdeskObserver = null;

  function hasSuperdeskRatingDefinition() {
    return Boolean(window.customElements && window.customElements.get('superdesk-star-rating-snippet'));
  }

  function waitForSuperdeskRatingDefinition() {
    if (hasSuperdeskRatingDefinition()) return Promise.resolve();
    if (!window.customElements || typeof window.customElements.whenDefined !== 'function') return Promise.resolve();

    if (!superdeskRatingReadyPromise) {
      superdeskRatingReadyPromise = window.customElements.whenDefined('superdesk-star-rating-snippet');
    }

    return superdeskRatingReadyPromise;
  }

  function ensureQuickBuySuperdesk(modal) {
    if (!modal) return;

    refreshProductAppMounts(modal);
    waitForSuperdeskRatingDefinition().then(function () {
      refreshProductAppMounts(modal);
    });
  }

  var cardRatingRowSyncFrame = null;

  function cardRatingListsIn(scope) {
    var root = scope || document;
    var lists = [];

    function addList(list) {
      if (list && lists.indexOf(list) === -1) lists.push(list);
    }

    if (root.matches && root.matches('product-list')) addList(root);
    if (root.closest) addList(root.closest('product-list'));
    if (root.querySelectorAll) root.querySelectorAll('product-list').forEach(addList);

    return lists;
  }

  function cardTitleSlotHeight(card) {
    var titleSlot = card.querySelector('.bup-product-card__title-slot');
    return titleSlot ? titleSlot.getBoundingClientRect().height : 0;
  }

  function groupCardsByVisualRow(cards) {
    return cards.reduce(function (rows, card) {
      var top = card.offsetTop;
      var row = rows.find(function (candidate) {
        return Math.abs(candidate.top - top) <= 1;
      });

      if (!row) {
        row = { top: top, cards: [] };
        rows.push(row);
      }

      row.cards.push(card);
      return rows;
    }, []);
  }

  function syncCardRatingRows(scope) {
    cardRatingListsIn(scope).forEach(function (list) {
      var cards = Array.prototype.slice.call(list.children).filter(function (child) {
        return child.matches && child.matches('product-card');
      });

      cards.forEach(function (card) {
        card.classList.remove('bup-card-swatch-row-empty');
        card.style.removeProperty('--bup-product-card-title-row-height');
      });

      groupCardsByVisualRow(cards).forEach(function (row) {
        var rowCards = row.cards;
        var titleRowHeight = rowCards.reduce(function (maximum, card) {
          return Math.max(maximum, cardTitleSlotHeight(card));
        }, 0);

        if (titleRowHeight > 0) {
          rowCards.forEach(function (card) {
            card.style.setProperty('--bup-product-card-title-row-height', Math.ceil(titleRowHeight) + 'px');
          });
        }
      });
    });
  }

  function scheduleCardRatingRowSync(scope) {
    if (cardRatingRowSyncFrame) return;

    cardRatingRowSyncFrame = window.requestAnimationFrame(function () {
      cardRatingRowSyncFrame = null;
      syncCardRatingRows(scope || document);
    });
  }

  var productCardSwatchRequests = new Map();
  var productCardSwatchImageRequests = new Map();
  var productCardSwatchPanel = null;
  var productCardSwatchPanelOpener = null;
  var productCardSwatchPanelCloseTimer = null;

  function getProductCardSwatchContainers(scope) {
    var root = scope || document;
    var containers = [];

    if (root.matches && root.matches('.bup-product-card-swatches[data-p][data-s]')) {
      containers.push(root);
    }

    if (root.querySelectorAll) {
      containers = containers.concat(Array.prototype.slice.call(root.querySelectorAll('.bup-product-card-swatches[data-p][data-s]')));
    }

    return containers;
  }

  function productCardSwatchRequest(productId, shopDomain) {
    var key = String(shopDomain) + ':' + String(productId);
    if (productCardSwatchRequests.has(key)) return productCardSwatchRequests.get(key);

    var url = new URL('/apps/renk-grubu/get-group', window.location.origin);
    url.searchParams.set('shop', shopDomain);
    url.searchParams.set('product_id', productId);
    url.searchParams.set('t', Date.now());

    var request = fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Product swatch group could not be loaded.');
        return response.json();
      })
      .catch(function (error) {
        productCardSwatchRequests.delete(key);
        throw error;
      });

    productCardSwatchRequests.set(key, request);
    return request;
  }

  function productCardSwatchProductId(product) {
    return String(product && product.id ? product.id : '').replace('gid://shopify/Product/', '');
  }

  function normalizeProductCardSwatchImageUrl(value) {
    if (!value) return '';

    if (typeof value === 'object') value = value.url || value.src || '';
    if (typeof value !== 'string') return '';

    if (value.indexOf('//') === 0) return window.location.protocol + value;
    return value;
  }

  function productCardSwatchImageUrl(product, fallback) {
    var appImage = product && (product.image || (product.featuredImage && product.featuredImage.url) || (product.featured_image && product.featured_image.url));
    return normalizeProductCardSwatchImageUrl(appImage) || normalizeProductCardSwatchImageUrl(fallback);
  }

  function productCardSwatchSizedImageUrl(value, width) {
    var imageUrl = normalizeProductCardSwatchImageUrl(value);
    if (!imageUrl || !width) return imageUrl;

    try {
      var parsedUrl = new URL(imageUrl, window.location.origin);
      if (parsedUrl.hostname.indexOf('cdn.shopify.com') > -1) {
        parsedUrl.searchParams.set('width', String(width));
        return parsedUrl.toString();
      }
    } catch (error) {
      return imageUrl;
    }

    return imageUrl;
  }

  function productCardSwatchProductImageRequest(product) {
    var handle = product && product.handle;
    if (!handle) return Promise.resolve('');

    if (productCardSwatchImageRequests.has(handle)) return productCardSwatchImageRequests.get(handle);

    var request = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Product card swatch image could not be loaded.');
        return response.json();
      })
      .then(function (liveProduct) {
        return productCardSwatchSizedImageUrl(liveProduct.featured_image || (liveProduct.images && liveProduct.images[0]), 720);
      })
      .catch(function () {
        return '';
      });

    productCardSwatchImageRequests.set(handle, request);
    return request;
  }

  function productCardSwatchLabel(product, container) {
    if (!product) return (container && container.dataset.currentColor) || '';
    if (product.color) return product.color;

    var productId = productCardSwatchProductId(product);
    var currentId = container ? String(container.getAttribute('data-p') || '') : '';
    var currentColor = container ? String(container.dataset.currentColor || '').trim() : '';

    if (currentColor && productId === currentId) return currentColor;

    var currentTitle = container ? String(container.dataset.currentTitle || '') : '';
    var productTitle = String(product.title || '').trim();
    var normalizedCurrentTitle = currentTitle.toLocaleLowerCase('tr-TR').split(/\s+/);
    var normalizedCurrentColor = currentColor.toLocaleLowerCase('tr-TR').split(/\s+/);
    var normalizedProductTitle = productTitle.split(/\s+/);
    var colorStart = -1;

    if (currentColor && currentTitle && productTitle) {
      for (var index = 0; index <= normalizedCurrentTitle.length - normalizedCurrentColor.length; index += 1) {
        if (normalizedCurrentTitle.slice(index, index + normalizedCurrentColor.length).join(' ') === normalizedCurrentColor.join(' ')) {
          colorStart = index;
          break;
        }
      }

      if (colorStart > 0) {
        var titlePrefix = normalizedCurrentTitle.slice(0, colorStart).join(' ');
        var productPrefix = normalizedProductTitle.slice(0, colorStart).join(' ').toLocaleLowerCase('tr-TR');

        if (titlePrefix === productPrefix) {
          var derivedWords = normalizedProductTitle.slice(colorStart);

          while (derivedWords.length && /^(elbise|gomlek|gömlek|ceket|kaban|trenc|trençkot|tunik|jile|etek|pantolon|yelek|takim|takım|ferace|bluz|hirka|hırka|sal|şal|esarp|eşarp|pelerin)$/i.test(derivedWords[derivedWords.length - 1])) {
            derivedWords.pop();
          }

          var derivedColor = derivedWords.join(' ').trim();
          if (derivedColor) return derivedColor;
        }
      }
    }

    return productTitle;
  }

  function productCardSwatchProducts(data) {
    var locationId = window.CSGA_LOCATION_ID || (window.Shopify && window.Shopify.pickup_location && window.Shopify.pickup_location.location_id) || data.primaryLocationId;

    return (data.products || []).slice().sort(function (a, b) {
      var aAvailable = a.availableForSale === true ? 1 : 0;
      var bAvailable = b.availableForSale === true ? 1 : 0;
      if (aAvailable !== bAvailable) return bAvailable - aAvailable;

      var aUntracked = a.tracksInventory === false ? 1 : 0;
      var bUntracked = b.tracksInventory === false ? 1 : 0;
      if (aUntracked !== bUntracked) return bUntracked - aUntracked;

      var aQuantity = locationId && a.locationStock && a.locationStock[locationId] !== undefined ? a.locationStock[locationId] : (a.inventoryQuantity || 0);
      var bQuantity = locationId && b.locationStock && b.locationStock[locationId] !== undefined ? b.locationStock[locationId] : (b.inventoryQuantity || 0);
      return bQuantity - aQuantity;
    });
  }

  function ensureProductCardSwatchPanel() {
    if (productCardSwatchPanel) return productCardSwatchPanel;

    var panel = document.createElement('div');
    var backdrop = document.createElement('button');
    var dialog = document.createElement('aside');
    var header = document.createElement('div');
    var title = document.createElement('h2');
    var close = document.createElement('button');
    var grid = document.createElement('div');

    panel.className = 'bup-product-card-swatch-panel';
    panel.id = 'bup-product-card-swatch-panel';
    panel.hidden = true;
    panel.setAttribute('aria-hidden', 'true');

    backdrop.type = 'button';
    backdrop.className = 'bup-product-card-swatch-panel__backdrop';
    backdrop.setAttribute('aria-label', 'Renk secenekleri panelini kapat');

    dialog.className = 'bup-product-card-swatch-panel__dialog';
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'bup-product-card-swatch-panel-title');
    dialog.setAttribute('tabindex', '-1');

    header.className = 'bup-product-card-swatch-panel__header';
    title.className = 'bup-product-card-swatch-panel__title';
    title.id = 'bup-product-card-swatch-panel-title';
    title.textContent = 'ÜRÜNÜN DİĞER RENKLERİ';

    close.type = 'button';
    close.className = 'bup-product-card-swatch-panel__close';
    close.setAttribute('aria-label', 'Kapat');
    close.textContent = '×';

    grid.className = 'bup-product-card-swatch-panel__grid';
    grid.setAttribute('data-bup-product-card-swatch-panel-grid', '');

    header.appendChild(title);
    header.appendChild(close);
    dialog.appendChild(header);
    dialog.appendChild(grid);
    panel.appendChild(backdrop);
    panel.appendChild(dialog);
    document.body.appendChild(panel);

    backdrop.addEventListener('click', closeProductCardSwatchPanel);
    close.addEventListener('click', closeProductCardSwatchPanel);

    productCardSwatchPanel = panel;
    return panel;
  }

  function closeProductCardSwatchPanel() {
    if (!productCardSwatchPanel || !productCardSwatchPanel.classList.contains('is-open')) return;

    if (productCardSwatchPanelCloseTimer) {
      window.clearTimeout(productCardSwatchPanelCloseTimer);
      productCardSwatchPanelCloseTimer = null;
    }

    var opener = productCardSwatchPanelOpener;
    productCardSwatchPanel.classList.remove('is-open');
    productCardSwatchPanel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bup-product-card-swatch-panel-open');
    document.documentElement.classList.remove('bup-product-card-swatch-panel-open');

    if (opener) opener.setAttribute('aria-expanded', 'false');

    productCardSwatchPanelCloseTimer = window.setTimeout(function () {
      if (!productCardSwatchPanel.classList.contains('is-open')) productCardSwatchPanel.hidden = true;
      productCardSwatchPanelCloseTimer = null;
    }, 220);

    productCardSwatchPanelOpener = null;
    if (opener && opener.isConnected) opener.focus();
  }

  function renderProductCardSwatchPanel(container, products) {
    var panel = ensureProductCardSwatchPanel();
    var grid = panel.querySelector('[data-bup-product-card-swatch-panel-grid]');
    var currentId = String(container.getAttribute('data-p') || '');

    grid.innerHTML = '';

    products.forEach(function (product) {
      var productId = productCardSwatchProductId(product);
      if (!product.handle || productId === currentId || String(product.id) === currentId) return;

      var colorLabel = productCardSwatchLabel(product, container);
      var item = document.createElement('a');
      var media = document.createElement('span');
      var label = document.createElement('span');

      item.className = 'bup-product-card-swatch-panel__item' + (product.availableForSale === false ? ' is-sold-out' : '');
      item.href = product.url || '/products/' + product.handle;
      item.setAttribute('aria-label', colorLabel || product.title || 'Renk secenegini incele');

      media.className = 'bup-product-card-swatch-panel__media';
      item.appendChild(media);

      productCardSwatchProductImageRequest(product).then(function (imageUrl) {
        if (!imageUrl || !media.isConnected) {
          media.classList.add('is-unavailable');
          return;
        }

        var image = document.createElement('img');
        image.className = 'bup-product-card-swatch-panel__image';
        image.src = imageUrl;
        image.alt = '';
        image.decoding = 'async';
        image.addEventListener('error', function () {
          image.remove();
          media.classList.add('is-unavailable');
        });
        media.appendChild(image);
      });

      label.className = 'bup-product-card-swatch-panel__label';
      label.textContent = colorLabel || product.title || '';
      item.appendChild(label);
      grid.appendChild(item);
    });

    return grid.children.length;
  }

  function openProductCardSwatchPanel(container, products, trigger) {
    var panel = ensureProductCardSwatchPanel();
    var visibleItemCount = renderProductCardSwatchPanel(container, products);
    if (!visibleItemCount) return;

    if (productCardSwatchPanelCloseTimer) {
      window.clearTimeout(productCardSwatchPanelCloseTimer);
      productCardSwatchPanelCloseTimer = null;
    }

    if (productCardSwatchPanelOpener && productCardSwatchPanelOpener !== trigger) {
      productCardSwatchPanelOpener.setAttribute('aria-expanded', 'false');
    }

    productCardSwatchPanelOpener = trigger;
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bup-product-card-swatch-panel-open');
    document.documentElement.classList.add('bup-product-card-swatch-panel-open');

    window.requestAnimationFrame(function () {
      panel.classList.add('is-open');
      var close = panel.querySelector('.bup-product-card-swatch-panel__close');
      if (close) close.focus();
    });
  }

  function renderProductCardSwatches(container, data) {
    var products = productCardSwatchProducts(data);
    var currentId = String(container.getAttribute('data-p') || '');
    var currentProduct = null;
    var alternativeProducts = [];

    products.forEach(function (product) {
      var productId = productCardSwatchProductId(product);
      var isCurrent = productId === currentId || String(product.id) === currentId;

      if (isCurrent) {
        currentProduct = product;
      } else {
        alternativeProducts.push(product);
      }
    });

    if (!currentProduct) {
      currentProduct = {
        id: currentId,
        title: container.dataset.currentTitle || '',
        color: container.dataset.currentColor || '',
        image: container.dataset.currentImage || ''
      };
    }

    if (alternativeProducts.length === 0) {
      container.classList.add('is-empty');
      container.setAttribute('aria-hidden', 'true');
      return;
    }

    var currentColorLabel = productCardSwatchLabel(currentProduct, container);
    var currentImageUrl = normalizeProductCardSwatchImageUrl(container.dataset.currentImage || '') || productCardSwatchImageUrl(currentProduct, '');
    var trigger = document.createElement('button');
    var preview = document.createElement('span');
    var image = document.createElement('img');
    var color = document.createElement('span');
    var more = document.createElement('span');

    container.innerHTML = '';
    container.classList.remove('is-empty');
    container.classList.add('is-ready');
    container.setAttribute('aria-hidden', 'false');

    trigger.type = 'button';
    trigger.className = 'bup-product-card-swatches__trigger';
    trigger.setAttribute('aria-controls', 'bup-product-card-swatch-panel');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-label', 'Diger renk seceneklerini goster');

    preview.className = 'bup-product-card-swatches__preview';
    if (currentImageUrl) {
      image.src = currentImageUrl;
      image.alt = '';
      image.decoding = 'async';
      image.addEventListener('error', function () {
        image.remove();
      });
      preview.appendChild(image);
    }

    color.className = 'bup-product-card-swatches__current-color';
    color.textContent = currentColorLabel || 'Renk';

    more.className = 'bup-product-card-swatches__more';
    more.textContent = '+' + alternativeProducts.length + ' renk';

    trigger.appendChild(preview);
    trigger.appendChild(color);
    trigger.appendChild(more);
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (productCardSwatchPanel && productCardSwatchPanel.classList.contains('is-open') && productCardSwatchPanelOpener === trigger) {
        closeProductCardSwatchPanel();
      } else {
        openProductCardSwatchPanel(container, products, trigger);
      }
    });

    container.appendChild(trigger);
  }

  function initializeProductCardSwatches(scope) {
    getProductCardSwatchContainers(scope).forEach(function (container) {
      if (container.dataset.bupSwatchesInitialized === 'true') return;
      container.dataset.bupSwatchesInitialized = 'true';

      var productId = container.getAttribute('data-p');
      var shopDomain = container.getAttribute('data-s');
      if (!productId || !shopDomain) return;

      productCardSwatchRequest(productId, shopDomain)
        .then(function (data) {
          if (!container.isConnected || !data || !data.success || !data.products || data.products.length <= 1) return;
          renderProductCardSwatches(container, data);
        })
        .catch(function () {
          container.classList.add('is-empty');
          container.setAttribute('aria-hidden', 'true');
        })
        .then(function () {
          scheduleCardRatingRowSync(container);
        });
    });
  }

  function scanQuickBuySuperdesk(scope) {
    var root = scope || document;
    if (root.matches && root.matches('quick-buy-modal')) ensureQuickBuySuperdesk(root);
    root.querySelectorAll('quick-buy-modal').forEach(ensureQuickBuySuperdesk);
  }

  function observeQuickBuySuperdesk() {
    if (quickBuySuperdeskObserver || !window.MutationObserver) return;

    quickBuySuperdeskObserver = new MutationObserver(function (records) {
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return;

          var modal = node.matches('quick-buy-modal') ? node : node.closest('quick-buy-modal');
          if (modal) ensureQuickBuySuperdesk(modal);
          if (node.querySelectorAll) node.querySelectorAll('quick-buy-modal').forEach(ensureQuickBuySuperdesk);
        });
      });
    });

    quickBuySuperdeskObserver.observe(document.documentElement, { childList: true, subtree: true });
    scanQuickBuySuperdesk(document);
  }

  var favKey = 'bupFavoriteProducts';
  var legacyFavKey = 'bls__wishlist-items';
  var favoriteDrawerRequestId = 0;

  function normalizeFavorites(value) {
    return (Array.isArray(value) ? value : []).reduce(function (favorites, handle) {
      var normalized = String(handle || '').trim();
      if (normalized && favorites.indexOf(normalized) === -1) favorites.push(normalized);
      return favorites;
    }, []);
  }

  function readFavorites(key) {
    try {
      return normalizeFavorites(JSON.parse(localStorage.getItem(key) || '[]'));
    } catch (e) {
      return [];
    }
  }

  function getFavorites() {
    var currentFavorites = readFavorites(favKey);
    var legacyFavorites = readFavorites(legacyFavKey);
    var favorites = normalizeFavorites(currentFavorites.concat(legacyFavorites));

    if (JSON.stringify(currentFavorites) !== JSON.stringify(favorites)) {
      try { localStorage.setItem(favKey, JSON.stringify(favorites)); } catch (e) {}
    }

    return favorites;
  }

  function favoriteElements(scope, selector) {
    var root = scope || document;
    var elements = [];

    if (root.matches && root.matches(selector)) elements.push(root);
    if (root.querySelectorAll) root.querySelectorAll(selector).forEach(function (element) { elements.push(element); });

    return elements;
  }

  function favoriteLabel(button, attribute, fallback) {
    return button.getAttribute(attribute) || fallback;
  }

  function updateFavoriteButton(button, favorites) {
    var handle = button.getAttribute('data-product-handle');
    if (!handle) return;

    var active = favorites.indexOf(handle) !== -1;
    var addLabel = favoriteLabel(button, 'data-bup-favorite-add-label', 'Favoriye ekle');
    var removeLabel = favoriteLabel(button, 'data-bup-favorite-remove-label', 'Favoriden kaldır');
    var productTitle = button.getAttribute('data-product-title');
    var label = active ? removeLabel : addLabel;
    var labelElement = button.querySelector('[data-bup-favorite-label]');

    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', label + (productTitle ? ': ' + productTitle : ''));
    button.classList.toggle('is-active', active);

    if (labelElement) labelElement.textContent = label;
  }

  function updateFavoriteCounts(favorites) {
    var count = favorites.length;
    var label = count ? 'Favorilerim, ' + count + ' ürün' : 'Favorilerim';

    document.querySelectorAll('[data-bup-favorite-count]').forEach(function (countElement) {
      countElement.textContent = count > 99 ? '99+' : String(count);
      countElement.hidden = count === 0;
    });

    document.querySelectorAll('[data-bup-favorites-open]').forEach(function (button) {
      button.setAttribute('aria-label', label);
    });
  }

  function hydrateFavorites(scope) {
    var favorites = getFavorites();
    favoriteElements(scope, '[data-bup-favorite-product]').forEach(function (button) {
      updateFavoriteButton(button, favorites);
    });
    updateFavoriteCounts(favorites);
  }

  function setFavorites(list) {
    var favorites = normalizeFavorites(list);

    try {
      var serialized = JSON.stringify(favorites);
      localStorage.setItem(favKey, serialized);
      localStorage.setItem(legacyFavKey, serialized);
    } catch (e) {}

    hydrateFavorites(document);

    document.querySelectorAll('[data-bup-favorites-drawer][open]').forEach(function (drawer) {
      renderFavoritesDrawer(drawer);
    });

    try {
      window.dispatchEvent(new CustomEvent('bup:favorites:updated', { detail: { handles: favorites } }));
    } catch (e) {}
  }

  function favoriteProductMarkup(product) {
    var handle = String(product.handle || '').trim();
    if (!handle) return '';

    var title = product.title || handle;
    var image = product.featured_image || '';
    var url = product.url || '/products/' + encodeURIComponent(handle);
    var price = Number(product.price) || 0;
    var compareAtPrice = Number(product.compare_at_price) || 0;

    return [
      '<article class="bup-favorites-drawer__item">',
        '<a class="bup-favorites-drawer__media" href="' + escapeHtml(url) + '">',
          image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '" loading="lazy">' : '',
        '</a>',
        '<div class="bup-favorites-drawer__details">',
          '<a class="bup-favorites-drawer__product-title" href="' + escapeHtml(url) + '">' + escapeHtml(title) + '</a>',
          '<div class="bup-favorites-drawer__price">',
            '<strong>' + escapeHtml(formatMoney(price)) + '</strong>',
            compareAtPrice > price ? '<s>' + escapeHtml(formatMoney(compareAtPrice)) + '</s>' : '',
          '</div>',
        '</div>',
        '<button type="button" class="bup-favorites-drawer__remove" data-bup-favorite-product data-product-handle="' + escapeHtml(handle) + '" data-product-title="' + escapeHtml(title) + '" data-bup-favorite-add-label="Favoriye ekle" data-bup-favorite-remove-label="Kaldır" aria-pressed="true">',
          '<span data-bup-favorite-label>Kaldır</span>',
        '</button>',
      '</article>'
    ].join('');
  }

  function favoriteLoadingMarkup(count) {
    return Array.from({ length: Math.min(count, 3) }, function () {
      return '<div class="bup-favorites-drawer__loading" aria-hidden="true"></div>';
    }).join('');
  }

  function favoriteProductRequestUrl(handle) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root.replace(/\/$/, '') + '/products/' + encodeURIComponent(handle) + '.js';
  }

  function renderFavoritesDrawer(drawer) {
    if (!drawer) return;

    var list = drawer.querySelector('[data-bup-favorites-list]');
    var emptyMessage = drawer.querySelector('[data-bup-favorites-empty]');
    var favorites = getFavorites();
    if (!list || !emptyMessage) return;

    favoriteDrawerRequestId += 1;
    var requestId = favoriteDrawerRequestId;

    if (!favorites.length) {
      list.innerHTML = '';
      emptyMessage.hidden = false;
      return;
    }

    emptyMessage.hidden = true;
    list.innerHTML = favoriteLoadingMarkup(favorites.length);

    Promise.all(favorites.map(function (handle) {
      return fetch(favoriteProductRequestUrl(handle), { credentials: 'same-origin' })
        .then(function (response) { return response.ok ? response.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      if (requestId !== favoriteDrawerRequestId) return;

      var markup = products.map(favoriteProductMarkup).filter(Boolean).join('');
      list.innerHTML = markup;
      emptyMessage.hidden = Boolean(markup);
      hydrateFavorites(list);
    }).catch(function () {
      if (requestId !== favoriteDrawerRequestId) return;
      list.innerHTML = '';
      emptyMessage.hidden = false;
    });
  }

  function closeFavoritesDrawer(drawer) {
    if (!drawer || !drawer.open) return;
    if (typeof drawer.close === 'function') drawer.close();
    else drawer.removeAttribute('open');
  }

  function openFavoritesDrawer(trigger) {
    var drawerId = trigger && trigger.getAttribute('aria-controls');
    var drawer = drawerId ? document.getElementById(drawerId) : document.querySelector('[data-bup-favorites-drawer]');
    if (!drawer) return;

    initializeFavoritesDrawer(drawer);
    if (!drawer.open) {
      try { drawer.showModal(); } catch (e) { drawer.setAttribute('open', ''); }
    }

    renderFavoritesDrawer(drawer);
  }

  function initializeFavoritesDrawer(scope) {
    favoriteElements(scope, '[data-bup-favorites-drawer]').forEach(function (drawer) {
      if (drawer.dataset.bupFavoritesInitialized === 'true') return;

      drawer.dataset.bupFavoritesInitialized = 'true';
      drawer.addEventListener('click', function (event) {
        if (event.target === drawer) closeFavoritesDrawer(drawer);
      });
      drawer.addEventListener('close', function () {
        favoriteDrawerRequestId += 1;
      });
    });
  }

  var inlineQuickBuyRequestId = 0;
  var inlineQuickBuyResizeObserver = null;

  function themeString(key, fallback) {
    return window.themeVariables && window.themeVariables.strings && window.themeVariables.strings[key] ? window.themeVariables.strings[key] : fallback;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  }

  var cartUpsellCache = new Map();
  var cartUpsellProducts = new Map();
  var activeUpsellSelection = null;
  var cartDrawerRefreshVersion = 0;
  var pendingCartDrawerRefresh = null;

  function uniqueList(values) {
    return values.reduce(function (list, value) {
      var normalized = String(value || '').trim();
      if (normalized && list.indexOf(normalized) === -1) list.push(normalized);
      return list;
    }, []);
  }

  function formatMoney(cents) {
    var amount = Number(cents || 0) / 100;
    var currency = window.Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : 'TRY';

    try {
      return new Intl.NumberFormat(Shopify.locale || 'tr-TR', { style: 'currency', currency: currency }).format(amount);
    } catch (error) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function getProductImage(product) {
    if (!product) return '';
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && product.featured_image.src) return product.featured_image.src;
    if (product.images && product.images.length) return typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
    return '';
  }

  function getAvailableVariants(product) {
    return (product && product.variants ? product.variants : []).filter(function (variant) {
      return variant.available !== false;
    });
  }

  function getDirectVariant(product) {
    var variants = getAvailableVariants(product);
    if (variants.length === 1) return variants[0];
    if (product && product.variants && product.variants.length === 1) return product.variants[0];
    return null;
  }

  function buildUpsellProperties(context, sourceProductId, position, productId) {
    return {
      _bup_upsell: 'true',
      _bup_upsell_source: String(context || ''),
      _bup_upsell_ref_product_id: String(sourceProductId || ''),
      _bup_upsell_position: String(position || ''),
      _bup_upsell_product_id: String(productId || '')
    };
  }

  function injectUpsellInputs(form, properties) {
    if (!form || !properties) return;
    Object.keys(properties).forEach(function (key) {
      var name = 'properties[' + key + ']';
      var input = form.querySelector('input[name="' + name + '"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = properties[key];
    });
  }

  function primeRelatedQuickBuyTracking(button) {
    var modalId = button && button.getAttribute('aria-controls');
    var modal = modalId ? document.getElementById(modalId) : null;
    if (!modal) return;

    var properties = buildUpsellProperties(
      button.getAttribute('data-bup-upsell-context'),
      button.getAttribute('data-bup-upsell-source-product-id'),
      button.getAttribute('data-bup-upsell-position'),
      button.getAttribute('data-bup-upsell-product-id')
    );

    var inject = function () {
      var form = modal.querySelector('form[action*="/cart/add"]');
      if (!form) return false;
      injectUpsellInputs(form, properties);
      return true;
    };

    if (inject()) return;

    var observer = new MutationObserver(function () {
      if (inject()) observer.disconnect();
    });
    observer.observe(modal, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 5000);
  }

  async function fetchRecommendationProducts(productId, intent) {
    var recommendationIntent = intent || 'related';
    var key = String(productId) + ':' + recommendationIntent;
    if (cartUpsellCache.has(key)) return cartUpsellCache.get(key);

    var request = fetch(rootUrl() + 'recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=8&intent=' + encodeURIComponent(recommendationIntent))
      .then(function (response) { return response.ok ? response.json() : { products: [] }; })
      .then(function (payload) { return payload.products || []; })
      .catch(function () { return []; });

    cartUpsellCache.set(key, request);
    return request;
  }

  function fetchRelatedProducts(productId) {
    return fetchRecommendationProducts(productId, 'related');
  }

  function fetchComplementaryProducts(productId) {
    return fetchRecommendationProducts(productId, 'complementary');
  }

  async function fetchFallbackUpsellProducts() {
    var key = 'fallback:all';
    if (cartUpsellCache.has(key)) return cartUpsellCache.get(key);

    var request = fetch(rootUrl() + 'collections/all/products.json?limit=12')
      .then(function (response) { return response.ok ? response.json() : { products: [] }; })
      .then(function (payload) { return payload.products || []; })
      .catch(function () { return []; });

    cartUpsellCache.set(key, request);
    return request;
  }

  function chooseUpsellProducts(cartProductIds, pools) {
    var cartSet = new Set(cartProductIds);
    var selectedIds = new Set();
    var selectedProducts = [];
    var sources = cartProductIds.slice(0, Math.min(cartProductIds.length, 3));
    var quotas = sources.length === 1 ? [3] : sources.length === 2 ? [1, 2] : [1, 1, 1];

    function pickFrom(sourceIndex, max) {
      var sourceId = sources[sourceIndex];
      var pool = pools[sourceIndex] || [];

      for (var i = 0; i < pool.length && max > 0 && selectedProducts.length < 3; i += 1) {
        var product = pool[i];
        var productId = String(product.id || '');
        if (!productId || cartSet.has(productId) || selectedIds.has(productId) || product.available === false || Number(product.price || 0) <= 0) continue;

        var copy = Object.assign({}, product);
        copy._bupSourceProductId = sourceId;
        selectedProducts.push(copy);
        selectedIds.add(productId);
        max -= 1;
      }
    }

    quotas.forEach(function (quota, index) { pickFrom(index, quota); });

    if (selectedProducts.length < 3) {
      sources.forEach(function (_sourceId, index) {
        pickFrom(index, 3 - selectedProducts.length);
      });
    }

    return selectedProducts.slice(0, 3);
  }

  function appendUpsellProducts(cartProductIds, selectedProducts, pools, sourceProductIds) {
    var cartSet = new Set(cartProductIds);
    var selectedIds = new Set(selectedProducts.map(function (product) { return String(product.id || ''); }));
    var products = selectedProducts.slice(0, 3);

    pools.forEach(function (pool, poolIndex) {
      if (products.length >= 3) return;

      for (var i = 0; i < pool.length && products.length < 3; i += 1) {
        var product = pool[i];
        var productId = String(product.id || '');

        if (!productId || cartSet.has(productId) || selectedIds.has(productId) || product.available === false || Number(product.price || 0) <= 0) continue;

        var copy = Object.assign({}, product);
        copy._bupSourceProductId = sourceProductIds[poolIndex] || sourceProductIds[0] || '';
        products.push(copy);
        selectedIds.add(productId);
      }
    });

    return products;
  }

  function renderCartUpsellCard(product, context, position) {
    var productId = String(product.id);
    var sourceProductId = product._bupSourceProductId || '';
    var image = getProductImage(product);
    var price = Number(product.price || 0);
    var compareAt = Number(product.compare_at_price || 0);
    cartUpsellProducts.set(productId, product);

    return [
      '<article class="bup-cart-upsell-card" data-bup-cart-upsell-card>',
        '<a class="bup-cart-upsell-card__media" href="' + escapeHtml(product.url || '#') + '">',
          image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '<span></span>',
        '</a>',
        '<div class="bup-cart-upsell-card__info">',
          '<a class="bup-cart-upsell-card__title" href="' + escapeHtml(product.url || '#') + '">' + escapeHtml(product.title) + '</a>',
          '<div class="bup-cart-upsell-card__price">',
            '<strong>' + escapeHtml(formatMoney(price)) + '</strong>',
            compareAt > price ? '<s>' + escapeHtml(formatMoney(compareAt)) + '</s>' : '',
          '</div>',
        '</div>',
        '<button class="bup-cart-upsell-card__add" type="button" data-bup-upsell-add data-product-id="' + escapeHtml(productId) + '" data-context="' + escapeHtml(context) + '" data-source-product-id="' + escapeHtml(sourceProductId) + '" data-position="' + position + '">',
          '<span>Sepete ekle</span>',
        '</button>',
      '</article>'
    ].join('');
  }

  function getCartUpsellContainers(scope) {
    var root = scope || document;
    var containers = [];

    if (root.matches && root.matches('[data-bup-cart-upsell]')) containers.push(root);
    if (root.querySelectorAll) containers = containers.concat(Array.from(root.querySelectorAll('[data-bup-cart-upsell]')));

    return Array.from(new Set(containers));
  }

  function refreshCartUpsells(scope) {
    cartUpsellCache.clear();
    cartUpsellProducts.clear();

    getCartUpsellContainers(scope).forEach(function (container) {
      container.removeAttribute('data-bup-loading');
      container.removeAttribute('data-bup-loaded');
    });

    hydrateCartUpsells(scope);
  }

  function scheduleCartDrawerRefreshAfterAdd() {
    var refreshVersion = cartDrawerRefreshVersion;

    if (pendingCartDrawerRefresh) window.clearTimeout(pendingCartDrawerRefresh);

    pendingCartDrawerRefresh = window.setTimeout(function () {
      pendingCartDrawerRefresh = null;
      if (cartDrawerRefreshVersion !== refreshVersion) return;

      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }, 600);
  }

  async function hydrateCartUpsells(scope) {
    var containers = getCartUpsellContainers(scope);
    if (!containers.length) return;

    await Promise.all(containers.map(async function (container) {
      if (container.getAttribute('data-bup-loading') === 'true' || container.getAttribute('data-bup-loaded') === 'true') return;

      var cartProductIds = uniqueList((container.getAttribute('data-cart-product-ids') || '').split(','));
      if (!cartProductIds.length) {
        container.hidden = true;
        container.setAttribute('data-bup-loaded', 'true');
        return;
      }

      container.setAttribute('data-bup-loading', 'true');
      var list = container.querySelector('[data-bup-cart-upsell-list]');
      if (!list) {
        container.hidden = true;
        container.removeAttribute('data-bup-loading');
        container.setAttribute('data-bup-loaded', 'true');
        return;
      }

      try {
        var sources = cartProductIds.slice(0, Math.min(cartProductIds.length, 3));
        var relatedPools = await Promise.all(sources.map(fetchRelatedProducts));
        var products = chooseUpsellProducts(cartProductIds, relatedPools);

        if (products.length < 3) {
          var complementaryPools = await Promise.all(sources.map(fetchComplementaryProducts));
          products = appendUpsellProducts(cartProductIds, products, complementaryPools, sources);
        }

        if (products.length < 3) {
          var fallbackProducts = await fetchFallbackUpsellProducts();
          products = appendUpsellProducts(cartProductIds, products, [fallbackProducts], [sources[0]]);
        }

        if (!products.length) {
          container.hidden = true;
          return;
        }

        container.hidden = false;
        list.innerHTML = products.map(function (product, index) {
          return renderCartUpsellCard(product, container.getAttribute('data-context'), index + 1);
        }).join('');
      } catch (error) {
        container.hidden = true;
      } finally {
        container.removeAttribute('data-bup-loading');
        container.setAttribute('data-bup-loaded', 'true');
      }
    }));
  }

  function isCustomerAccountPath() {
    return /(?:^|\/)account(?:\/|$)/.test(window.location.pathname || '');
  }

  function isAccountNavigationLink(link) {
    if (!link || !isCustomerAccountPath()) return false;

    var label = (link.getAttribute('aria-label') || link.textContent || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase('tr-TR');
    return /puan|favor|adres|iade|değişim|degisim|incelenen|şifre|sifre|sipariş|siparis|hesap/.test(label);
  }

  function normalizeAccountNavigationTargets(scope) {
    if (!isCustomerAccountPath()) return;

    var root = scope || document;
    var links = root.querySelectorAll ? Array.from(root.querySelectorAll('a[href]')) : [];
    if (root.matches && root.matches('a[href]')) links.unshift(root);

    links.forEach(function (link) {
      if (!isAccountNavigationLink(link)) return;

      link.setAttribute('data-bup-same-tab-account-link', 'true');
      link.removeAttribute('target');
      link.removeAttribute('rel');
    });
  }

  function ensureUpsellPicker() {
    var picker = document.querySelector('[data-bup-upsell-picker]');
    if (picker) return picker;

    picker = document.createElement('div');
    picker.className = 'bup-upsell-picker';
    picker.setAttribute('data-bup-upsell-picker', '');
    picker.hidden = true;
    picker.innerHTML = [
      '<div class="bup-upsell-picker__backdrop" data-bup-upsell-close></div>',
      '<div class="bup-upsell-picker__dialog" role="dialog" aria-modal="true" aria-labelledby="bup-upsell-picker-title">',
        '<button class="bup-upsell-picker__close" type="button" data-bup-upsell-close aria-label="Kapat">×</button>',
        '<p class="h5" id="bup-upsell-picker-title">Beden seçin</p>',
        '<div class="bup-upsell-picker__product">',
          '<img alt="" data-bup-upsell-picker-image>',
          '<div>',
            '<span class="bup-upsell-picker__eyebrow">Seçilen ürün</span>',
            '<p data-bup-upsell-picker-title></p>',
            '<div class="bup-cart-upsell-card__price" data-bup-upsell-picker-price></div>',
          '</div>',
        '</div>',
        '<label class="bup-upsell-picker__field">',
          '<span>Varyant</span>',
          '<select data-bup-upsell-picker-select></select>',
        '</label>',
        '<button class="button bup-upsell-picker__submit" type="button" data-bup-upsell-picker-add>Sepete ekle</button>',
      '</div>'
    ].join('');
    document.body.appendChild(picker);
    return picker;
  }

  function closeUpsellPicker() {
    var picker = document.querySelector('[data-bup-upsell-picker]');
    if (!picker) return;
    picker.hidden = true;
    document.documentElement.classList.remove('bup-upsell-picker-open');
    activeUpsellSelection = null;
  }

  function openUpsellPicker(product, triggerButton) {
    var picker = ensureUpsellPicker();
    var variants = getAvailableVariants(product);
    var image = getProductImage(product);
    var select = picker.querySelector('[data-bup-upsell-picker-select]');
    var price = Number(product.price || 0);
    var compareAt = Number(product.compare_at_price || 0);

    activeUpsellSelection = {
      product: product,
      context: triggerButton.getAttribute('data-context'),
      sourceProductId: triggerButton.getAttribute('data-source-product-id'),
      position: triggerButton.getAttribute('data-position')
    };

    picker.querySelector('[data-bup-upsell-picker-image]').src = image || '';
    picker.querySelector('[data-bup-upsell-picker-image]').hidden = !image;
    picker.querySelector('[data-bup-upsell-picker-title]').textContent = product.title || '';
    picker.querySelector('[data-bup-upsell-picker-price]').innerHTML = '<strong>' + escapeHtml(formatMoney(price)) + '</strong>' + (compareAt > price ? ' <s>' + escapeHtml(formatMoney(compareAt)) + '</s>' : '');
    select.innerHTML = variants.map(function (variant) {
      var title = variant.title && variant.title !== 'Default Title' ? variant.title : product.title;
      return '<option value="' + escapeHtml(variant.id) + '">' + escapeHtml(title) + '</option>';
    }).join('');
    picker.hidden = false;
    document.documentElement.classList.add('bup-upsell-picker-open');
    select.focus({ preventScroll: true });
  }

  async function handleCartUpsellAdd(button) {
    var product = cartUpsellProducts.get(String(button.getAttribute('data-product-id')));
    if (!product) return;

    var directVariant = getDirectVariant(product);
    if (!directVariant) {
      openUpsellPicker(product, button);
      return;
    }

    await addVariant(directVariant.id, button, buildUpsellProperties(
      button.getAttribute('data-context'),
      button.getAttribute('data-source-product-id'),
      button.getAttribute('data-position'),
      product.id
    ));
  }

  function resetInlineQuickBuyButtons(scope) {
    (scope || document).querySelectorAll('[data-bup-inline-quick-buy-trigger][aria-expanded="true"]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
      button.classList.remove('is-active');
    });
  }

  function syncInlineQuickBuyHeight(panel) {
    if (!panel || panel.hidden) return;
    panel.style.setProperty('--bup-inline-quick-buy-height', panel.scrollHeight + 'px');
  }

  function watchInlineQuickBuyPanel(panel) {
    if (inlineQuickBuyResizeObserver) inlineQuickBuyResizeObserver.disconnect();
    if (!('ResizeObserver' in window)) return;

    inlineQuickBuyResizeObserver = new ResizeObserver(function () {
      syncInlineQuickBuyHeight(panel);
    });

    var shell = panel.querySelector('.bup-inline-quick-buy__shell');
    if (shell) inlineQuickBuyResizeObserver.observe(shell);
  }

  function createInlineQuickBuyPanel(panelId) {
    var panel = document.createElement('div');
    panel.id = panelId;
    panel.hidden = true;
    panel.className = 'bup-inline-quick-buy bup-inline-quick-buy--bar';
    panel.setAttribute('data-bup-inline-quick-buy-panel', '');
    panel.setAttribute('aria-hidden', 'true');
    panel.innerHTML = [
      '<div class="bup-inline-quick-buy__shell">',
      '<button class="bup-inline-quick-buy__close" type="button" data-bup-inline-quick-buy-close aria-label="' + escapeHtml(themeString('close', 'Close')) + '">',
      '<svg aria-hidden="true" viewBox="0 0 16 16"><path d="M4 4l8 8M12 4l-8 8"/></svg>',
      '</button>',
      '<div class="bup-inline-quick-buy__body" data-bup-inline-quick-buy-body></div>',
      '</div>'
    ].join('');
    return panel;
  }

  function ensureInlineQuickBuyPanel(list, panelId) {
    var panel = list.querySelector('[data-bup-inline-quick-buy-panel]');
    if (!panel) {
      panel = createInlineQuickBuyPanel(panelId);
    } else {
      panel.id = panelId;
    }
    return panel;
  }

  function getInlineQuickBuyRowEnd(card, list, panel) {
    var cardRect = card.getBoundingClientRect();
    var rowTop = Math.round(cardRect.top);
    var rowItems = Array.from(list.children).filter(function (item) {
      if (item === panel || item.hidden) return false;
      if (!item.matches('product-card, .product-list__promo')) return false;
      return Math.abs(Math.round(item.getBoundingClientRect().top) - rowTop) <= 3;
    });

    return rowItems.length ? rowItems[rowItems.length - 1] : card;
  }

  function placeInlineQuickBuyPanel(panel, trigger) {
    var list = trigger.closest('[data-bup-inline-quick-buy-list]');
    var card = trigger.closest('product-card');
    if (!list || !card) return false;

    var rowEnd = getInlineQuickBuyRowEnd(card, list, panel);
    list.insertBefore(panel, rowEnd.nextSibling);
    return true;
  }

  function prepareInlineQuickBuyBar(panel) {
    if (!panel) return;
    panel.classList.add('bup-inline-quick-buy--bar');

    panel.querySelectorAll('.quick-buy-modal__gallery-wrapper, .quick-buy-modal__mobile-info').forEach(function (element) {
      element.remove();
    });

    panel.querySelectorAll('.quick-buy-modal__view-more').forEach(function (link) {
      link.textContent = 'Ürün detayına git';
    });

    hydrateCampaignCodes(panel);
    startCampaignCountdowns(panel);
    refreshProductAppMounts(panel);
  }

  function getInlineQuickBuyProductUrlFromOption(event, panel) {
    var directLink = event.target.closest('variant-picker a[href]');
    if (directLink) return directLink.getAttribute('href');

    var optionInput = event.target.closest('input[data-product-url]');
    if (!optionInput) {
      var optionLabel = event.target.closest('label[for]');
      var optionId = optionLabel && optionLabel.getAttribute('for');

      if (optionId && window.CSS && CSS.escape) {
        optionInput = panel.querySelector('#' + CSS.escape(optionId));
      } else if (optionId) {
        optionInput = panel.querySelector('[id="' + optionId.replace(/"/g, '\\"') + '"]');
      }
    }

    return optionInput && optionInput.getAttribute('data-product-url');
  }

  function setInlineQuickBuyLoading(panel) {
    var body = panel.querySelector('[data-bup-inline-quick-buy-body]');
    panel.classList.add('is-loading');
    panel.setAttribute('aria-busy', 'true');
    body.innerHTML = '<div class="bup-inline-quick-buy__loading bup-inline-quick-buy__loading--bar" aria-hidden="true"><span></span><span></span><span></span><span></span><span></span><span></span></div>';
    syncInlineQuickBuyHeight(panel);
  }

  function closeInlineQuickBuyPanel(panel, immediate) {
    if (!panel) return;

    var list = panel.closest('[data-bup-inline-quick-buy-list]');
    if (list) resetInlineQuickBuyButtons(list);
    panel.classList.remove('is-open', 'is-loading');
    panel.setAttribute('aria-hidden', 'true');
    panel.setAttribute('aria-busy', 'false');
    inlineQuickBuyRequestId += 1;

    var closeToken = String(Date.now());
    panel.setAttribute('data-bup-inline-close-token', closeToken);

    var finishClose = function () {
      if (panel.getAttribute('data-bup-inline-close-token') !== closeToken || panel.classList.contains('is-open')) return;
      var body = panel.querySelector('[data-bup-inline-quick-buy-body]');
      if (body) body.innerHTML = '';
      panel.hidden = true;
      panel.style.removeProperty('--bup-inline-quick-buy-height');
      if (inlineQuickBuyResizeObserver) inlineQuickBuyResizeObserver.disconnect();
    };

    if (immediate) {
      finishClose();
    } else {
      window.setTimeout(finishClose, 460);
    }
  }

  function scrollInlineQuickBuyIntoView(panel) {
    var rect = panel.getBoundingClientRect();
    var stickyHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-area-height')) || 0;
    ['.shopify-section--header', '.collection-toolbar'].forEach(function (selector) {
      var element = document.querySelector(selector);
      if (!element) return;
      var elementRect = element.getBoundingClientRect();
      if (elementRect.height > 0 && elementRect.top <= stickyHeight + 2 && elementRect.bottom > stickyHeight) {
        stickyHeight = Math.max(stickyHeight, elementRect.bottom);
      }
    });

    if (rect.top < stickyHeight + 8 || rect.top > window.innerHeight * 0.72) {
      window.scrollTo({ top: window.scrollY + rect.top - stickyHeight - 12, behavior: 'smooth' });
    }
  }

  async function openInlineQuickBuy(trigger) {
    var list = trigger.closest('[data-bup-inline-quick-buy-list]');
    if (!list) return;

    var panelId = trigger.getAttribute('aria-controls') || 'bup-inline-quick-buy-panel';
    var handle = trigger.getAttribute('data-bup-inline-quick-buy-handle');
    var variantId = trigger.getAttribute('data-bup-inline-quick-buy-variant');
    var currentPanel = list.querySelector('[data-bup-inline-quick-buy-panel]');

    if (currentPanel && currentPanel.classList.contains('is-open') && currentPanel.getAttribute('data-product-handle') === handle) {
      closeInlineQuickBuyPanel(currentPanel);
      return;
    }

    if (currentPanel) closeInlineQuickBuyPanel(currentPanel, true);

    var panel = ensureInlineQuickBuyPanel(list, panelId);
    panel.classList.add('bup-inline-quick-buy--bar');
    if (!placeInlineQuickBuyPanel(panel, trigger)) return;

    resetInlineQuickBuyButtons(list);
    trigger.setAttribute('aria-expanded', 'true');
    trigger.classList.add('is-active');

    panel.hidden = false;
    panel.setAttribute('aria-hidden', 'false');
    panel.setAttribute('data-product-handle', handle || '');
    panel.removeAttribute('data-bup-inline-close-token');
    setInlineQuickBuyLoading(panel);

    window.requestAnimationFrame(function () {
      panel.classList.add('is-open');
      syncInlineQuickBuyHeight(panel);
      scrollInlineQuickBuyIntoView(panel);
    });

    var requestId = ++inlineQuickBuyRequestId;

    try {
      var productUrl = rootUrl() + 'products/' + encodeURIComponent(handle || '');
      if (variantId) productUrl += '?variant=' + encodeURIComponent(variantId);

      var response = await fetch(productUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error('Quick buy request failed');
      if (requestId !== inlineQuickBuyRequestId) return;

      var tempDoc = new DOMParser().parseFromString(await response.text(), 'text/html');
      var quickBuyTemplate = tempDoc.getElementById('quick-buy-content');
      if (!quickBuyTemplate) throw new Error('Quick buy template missing');

      var content = quickBuyTemplate.content.cloneNode(true);
      content.querySelectorAll('noscript, [slot="header"]').forEach(function (element) {
        element.remove();
      });
      content.querySelectorAll('.quick-buy-modal__close-button').forEach(function (button) {
        var wrapper = button.closest('dialog-close-button');
        (wrapper || button).remove();
      });

      var body = panel.querySelector('[data-bup-inline-quick-buy-body]');
      body.replaceChildren(content);
      prepareInlineQuickBuyBar(panel);
      panel.classList.remove('is-loading');
      panel.setAttribute('aria-busy', 'false');
      normalizeVideoEmbeds(panel);
      window.Shopify && window.Shopify.PaymentButton && window.Shopify.PaymentButton.init();
      watchInlineQuickBuyPanel(panel);
      syncInlineQuickBuyHeight(panel);
      scrollInlineQuickBuyIntoView(panel);
      panel.querySelectorAll('img').forEach(function (image) {
        if (!image.complete) {
          image.addEventListener('load', function () {
            syncInlineQuickBuyHeight(panel);
            scrollInlineQuickBuyIntoView(panel);
          }, { once: true });
        }
      });
    } catch (error) {
      if (requestId !== inlineQuickBuyRequestId) return;
      var errorBody = panel.querySelector('[data-bup-inline-quick-buy-body]');
      errorBody.innerHTML = '<div class="banner banner--error" role="alert">' + escapeHtml(themeString('quickBuyError', 'Ürün seçenekleri yüklenemedi.')) + '</div>';
      panel.classList.remove('is-loading');
      panel.setAttribute('aria-busy', 'false');
      syncInlineQuickBuyHeight(panel);
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!form.closest('product-form[data-bup-visual-only-product]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest && event.target.closest('a[href]');
    if (!isAccountNavigationLink(link) || link.hasAttribute('download')) return;

    normalizeAccountNavigationTargets(link);
    var destination = link.href;
    if (!destination || /^javascript:/i.test(destination)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(destination);
  }, true);

  document.addEventListener('click', function (event) {
    var clearCartButton = event.target.closest('[data-bup-clear-cart]');
    if (clearCartButton) {
      event.preventDefault();
      clearCart(clearCartButton);
      return;
    }

    var favoritesOpen = event.target.closest('[data-bup-favorites-open]');
    if (favoritesOpen) {
      event.preventDefault();
      var openSidebar = favoritesOpen.closest('.header-sidebar[open]');
      if (openSidebar && typeof openSidebar.hide === 'function') {
        Promise.resolve(openSidebar.hide()).then(function () {
          openFavoritesDrawer(favoritesOpen);
        });
      } else {
        openFavoritesDrawer(favoritesOpen);
      }
      return;
    }

    var favoritesClose = event.target.closest('[data-bup-favorites-close]');
    if (favoritesClose) {
      event.preventDefault();
      closeFavoritesDrawer(favoritesClose.closest('[data-bup-favorites-drawer]'));
      return;
    }

    var loyaltyTrigger = event.target.closest('[data-bup-loyalty-trigger]');
    if (loyaltyTrigger) {
      event.preventDefault();

      function openLoyaltyWidget() {
        var launcher = document.getElementById('appstle-loyalty-button');
        if (!launcher) return false;
        launcher.click();
        return true;
      }

      if (!openLoyaltyWidget()) {
        window.setTimeout(openLoyaltyWidget, 500);
      }
      return;
    }

    var productShareTrigger = event.target.closest('[data-bup-share]');
    if (productShareTrigger) {
      event.preventDefault();
      shareProduct(productShareTrigger);
      return;
    }

    var inlineProductOptionPanel = event.target.closest('[data-bup-inline-quick-buy-panel]');
    if (inlineProductOptionPanel) {
      var inlineProductUrl = getInlineQuickBuyProductUrlFromOption(event, inlineProductOptionPanel);

      if (inlineProductUrl) {
        event.preventDefault();
        window.location.href = inlineProductUrl;
        return;
      }
    }

    var kombinQuantityButton = event.target.closest('[data-bup-kombin-quantity]');
    if (kombinQuantityButton) {
      event.preventDefault();
      var kombinItem = kombinQuantityButton.closest('[data-bup-kombin-item]');
      var quantityValue = kombinItem && kombinItem.querySelector('[data-bup-kombin-quantity-value]');
      var quantityDelta = Number(kombinQuantityButton.getAttribute('data-bup-kombin-quantity') || 0);

      if (quantityValue && quantityDelta) {
        quantityValue.textContent = String(Math.max(1, (Number(quantityValue.textContent) || 1) + quantityDelta));
        updateKombinBundle(kombinQuantityButton.closest('[data-bup-kombin-bundle]'));
      }
      return;
    }

    var kombinAddButton = event.target.closest('[data-bup-kombin-add]');
    if (kombinAddButton) {
      event.preventDefault();
      addKombinBundle(kombinAddButton);
      return;
    }

    var campaignCode = event.target.closest('[data-bup-campaign-copy]');
    if (campaignCode) {
      event.preventDefault();
      copyCampaignCode(campaignCode);
      return;
    }

    var relatedQuickBuyButton = event.target.closest('[data-bup-related-quick-buy]');
    if (relatedQuickBuyButton) {
      primeRelatedQuickBuyTracking(relatedQuickBuyButton);
    }

    var upsellAddButton = event.target.closest('[data-bup-upsell-add]');
    if (upsellAddButton) {
      event.preventDefault();
      handleCartUpsellAdd(upsellAddButton);
      return;
    }

    var upsellPickerClose = event.target.closest('[data-bup-upsell-close]');
    if (upsellPickerClose) {
      event.preventDefault();
      closeUpsellPicker();
      return;
    }

    var upsellPickerAdd = event.target.closest('[data-bup-upsell-picker-add]');
    if (upsellPickerAdd) {
      event.preventDefault();
      if (!activeUpsellSelection) return;
      var picker = upsellPickerAdd.closest('[data-bup-upsell-picker]');
      var select = picker && picker.querySelector('[data-bup-upsell-picker-select]');
      var variantId = select && select.value;
      if (!variantId) return;

      addVariant(variantId, upsellPickerAdd, buildUpsellProperties(
        activeUpsellSelection.context,
        activeUpsellSelection.sourceProductId,
        activeUpsellSelection.position,
        activeUpsellSelection.product.id
      )).then(closeUpsellPicker);
      return;
    }

    var inlineQuickBuyTrigger = event.target.closest('[data-bup-inline-quick-buy-trigger]');
    if (inlineQuickBuyTrigger) {
      event.preventDefault();
      openInlineQuickBuy(inlineQuickBuyTrigger);
      return;
    }

    var inlineQuickBuyClose = event.target.closest('[data-bup-inline-quick-buy-close]');
    if (inlineQuickBuyClose) {
      event.preventDefault();
      closeInlineQuickBuyPanel(inlineQuickBuyClose.closest('[data-bup-inline-quick-buy-panel]'));
      return;
    }

    var addButton = event.target.closest('[data-bup-add-variant]');
    if (addButton) {
      event.preventDefault();
      addVariant(addButton.getAttribute('data-bup-add-variant'), addButton);
      return;
    }

    var favoriteButton = event.target.closest('[data-bup-favorite-product]');
    if (favoriteButton) {
      event.preventDefault();
      var handle = favoriteButton.getAttribute('data-product-handle');
      if (!handle) return;

      var favorites = getFavorites();
      var index = favorites.indexOf(handle);
      if (index === -1) {
        favorites.push(handle);
      } else {
        favorites.splice(index, 1);
      }
      setFavorites(favorites);
      return;
    }

    var weeklyToggle = event.target.closest('[data-bup-weekly-toggle]');
    if (weeklyToggle) {
      event.preventDefault();
      var root = weeklyToggle.closest('[data-bup-weekly-offer]');
      setWeeklyOfferState(root, !root.classList.contains('is-open'));
      return;
    }

    var weeklyClose = event.target.closest('[data-bup-weekly-close]');
    if (weeklyClose) {
      event.preventDefault();
      setWeeklyOfferState(weeklyClose.closest('[data-bup-weekly-offer]'), false);
      return;
    }

    var openButton = event.target.closest('[data-bup-video-open]');
    if (openButton) {
      event.preventDefault();
      openVideo(document.getElementById(openButton.getAttribute('data-bup-video-open')));
      return;
    }

    var closeButton = event.target.closest('[data-bup-video-close]');
    if (closeButton) {
      event.preventDefault();
      closeVideo(closeButton.closest('[data-bup-video-modal]'));
      return;
    }

    var modal = event.target.closest('[data-bup-video-modal]');
    if (modal && event.target === modal) closeVideo(modal);
  }, true);

  document.addEventListener('change', function (event) {
    var kombinControl = event.target.closest('[data-bup-kombin-check], [data-bup-kombin-variant]');
    if (kombinControl) {
      updateKombinBundle(kombinControl.closest('[data-bup-kombin-bundle]'));
      return;
    }

    var checkbox = event.target.closest('[data-bup-gift-checkbox]');
    if (!checkbox) return;
    var wrap = checkbox.closest('[data-bup-gift-wrap]');
    var variantId = wrap && wrap.getAttribute('data-variant-id');
    checkbox.disabled = true;
    (checkbox.checked ? addVariant(variantId) : removeVariant(variantId)).finally(function () {
      checkbox.disabled = false;
    });
  });

  document.addEventListener('wheel', function (event) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var carousel = event.target.closest('[data-bup-wheel-scroll]');
    if (!carousel) return;

    var maxScroll = carousel.scrollWidth - carousel.clientWidth;
    if (maxScroll <= 1) return;

    var delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
    if (!delta) return;

    var nextScroll = Math.min(maxScroll, Math.max(0, carousel.scrollLeft + delta));
    if (nextScroll === carousel.scrollLeft) return;

    event.preventDefault();
    carousel.scrollLeft = nextScroll;
  }, { passive: false });

  function footerMenusIn(scope) {
    var root = scope && scope.nodeType === Node.ELEMENT_NODE ? scope : document;
    var menus = [];

    if (root.matches && root.matches('[data-bup-footer-menu]')) menus.push(root);
    if (root.querySelectorAll) menus = menus.concat(Array.prototype.slice.call(root.querySelectorAll('[data-bup-footer-menu]')));

    return menus;
  }

  var footerMenuMediaBound = false;

  function isFooterAccordionMode() {
    return window.matchMedia('(max-width: 699px)').matches;
  }

  function syncFooterMenus(scope) {
    footerMenusIn(scope).forEach(function (menu) {
      if (isFooterAccordionMode()) {
        if (menu.dataset.bupFooterDesktopOpen === 'true') {
          menu.open = false;
          delete menu.dataset.bupFooterDesktopOpen;
        }
        return;
      }

      menu.open = true;
      menu.dataset.bupFooterDesktopOpen = 'true';
    });
  }

  function initializeFooterMenus(scope) {
    footerMenusIn(scope).forEach(function (menu) {
      if (menu.dataset.bupFooterMenuBound === 'true') return;

      menu.dataset.bupFooterMenuBound = 'true';
      menu.addEventListener('click', function (event) {
        if (!isFooterAccordionMode() && event.target.closest('.bup-footer-menu__summary')) {
          event.preventDefault();
        }
      });
      menu.addEventListener('toggle', function () {
        if (!menu.open || !isFooterAccordionMode()) return;

        var footer = menu.closest('.footer');
        if (!footer) return;

        footer.querySelectorAll('[data-bup-footer-menu][open]').forEach(function (otherMenu) {
          if (otherMenu !== menu) otherMenu.open = false;
        });
      });
    });

    syncFooterMenus(scope);

    if (!footerMenuMediaBound) {
      footerMenuMediaBound = true;
      var footerMediaQuery = window.matchMedia('(max-width: 699px)');
      var handleFooterViewportChange = function () { syncFooterMenus(document); };

      if (footerMediaQuery.addEventListener) {
        footerMediaQuery.addEventListener('change', handleFooterViewportChange);
      } else {
        footerMediaQuery.addListener(handleFooterViewportChange);
      }
    }
  }

  function headerDisclosuresIn(scope) {
    var root = scope && scope.nodeType === Node.ELEMENT_NODE ? scope : document;
    var disclosures = [];

    if (root.matches && root.matches('mega-menu-disclosure, dropdown-menu-disclosure')) disclosures.push(root);
    if (root.querySelectorAll) disclosures = disclosures.concat(Array.prototype.slice.call(root.querySelectorAll('mega-menu-disclosure, dropdown-menu-disclosure')));

    return disclosures.filter(function (disclosure) {
      return disclosure.parentElement && disclosure.parentElement.matches('.header__primary-nav-item, .bup-live-desktop-nav__item--disclosure');
    });
  }

  function closeHeaderDisclosureImmediately(menu) {
    var details = menu && menu.querySelector('details.header__menu-disclosure, details.bup-live-desktop-nav__disclosure');
    if (!details || !details.open) return;

    if (typeof menu.toggle === 'function') {
      try { menu.toggle(false); } catch (error) {}
    }

    details.open = false;
    details.removeAttribute('open');
    details.setAttribute('aria-expanded', 'false');
    details.style.height = '';
    details.style.overflow = '';
  }

  function closeOtherHeaderDisclosures(activeMenu) {
    headerDisclosuresIn(document).forEach(function (menu) {
      if (menu !== activeMenu) closeHeaderDisclosureImmediately(menu);
    });
  }

  function initializeHeaderDisclosures(scope) {
    headerDisclosuresIn(scope).forEach(function (menu) {
      if (menu.dataset.bupMegaMenuBound === 'true') return;

      var details = menu.querySelector('details.header__menu-disclosure, details.bup-live-desktop-nav__disclosure');
      if (!details) return;

      menu.dataset.bupMegaMenuBound = 'true';
      menu.addEventListener('mouseenter', function () {
        if (!window.matchMedia('screen and (min-width: 1000px) and (pointer: fine)').matches) return;
        closeOtherHeaderDisclosures(menu);
      });
      menu.addEventListener('focusin', function () {
        if (window.matchMedia('(min-width: 1000px)').matches) closeOtherHeaderDisclosures(menu);
      });
      details.addEventListener('toggle', function () {
        if (details.open && window.matchMedia('(min-width: 1000px)').matches) closeOtherHeaderDisclosures(menu);
      });
    });
  }

  function buildCollectionSizeFilterUrl(root, value) {
    var filterParam = root.getAttribute('data-bup-size-filter-param');
    if (!filterParam || !value) return null;

    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete(filterParam);
    url.searchParams.set(filterParam, value);
    return url;
  }

  function updateCollectionSizeFilter(root, value) {
    var sectionId = root.getAttribute('data-section-id');
    var url = buildCollectionSizeFilterUrl(root, value);
    if (!sectionId || !url) return;

    url.searchParams.set('section_id', sectionId);
    root.dispatchEvent(new CustomEvent('facet:update', {
      bubbles: true,
      detail: { url: url }
    }));
  }

  function initializeCollectionSizeFilters(scope) {
    var root = scope && scope.nodeType === Node.ELEMENT_NODE ? scope : document;
    var filters = [];

    if (root.matches && root.matches('[data-bup-collection-size-filter]')) filters.push(root);
    if (root.querySelectorAll) filters = filters.concat(Array.prototype.slice.call(root.querySelectorAll('[data-bup-collection-size-filter]')));

    filters.forEach(function (filter) {
      if (filter.dataset.bupSizeFilterBound === 'true') return;

      filter.dataset.bupSizeFilterBound = 'true';
      filter.addEventListener('click', function (event) {
        var option = event.target.closest && event.target.closest('[data-bup-size-filter-option]');
        if (!option || !filter.contains(option)) return;

        event.preventDefault();
        filter.dataset.bupSizeFilterDefaultPending = 'false';
        updateCollectionSizeFilter(filter, option.getAttribute('data-bup-size-filter-value'));
      });

      if (filter.dataset.bupSizeFilterDefaultPending !== 'true') return;

      window.requestAnimationFrame(function () {
        if (!filter.isConnected || filter.dataset.bupSizeFilterDefaultPending !== 'true') return;

        filter.dataset.bupSizeFilterDefaultPending = 'false';
        updateCollectionSizeFilter(filter, filter.getAttribute('data-bup-size-filter-default-value'));
      });
    });
  }

  function setCollectionInfiniteState(pager, loading, message) {
    var status = pager.querySelector('[data-bup-collection-status]');

    pager.dataset.bupCollectionInfiniteLoading = loading ? 'true' : 'false';
    pager.setAttribute('aria-busy', loading ? 'true' : 'false');

    if (status) status.textContent = message || (loading ? 'Ürünler yükleniyor.' : '');
  }

  function stopCollectionInfiniteObserver(pager) {
    if (pager._bupCollectionInfiniteObserver) {
      pager._bupCollectionInfiniteObserver.disconnect();
      pager._bupCollectionInfiniteObserver = null;
    }

    if (pager._bupCollectionInfiniteFallback) {
      window.removeEventListener('scroll', pager._bupCollectionInfiniteFallback);
      window.removeEventListener('resize', pager._bupCollectionInfiniteFallback);
      pager._bupCollectionInfiniteFallback = null;
    }
  }

  function requestCollectionInfiniteHtml(url) {
    return fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Collection page could not be loaded.');
        return response.text();
      });
  }

  function parseCollectionInfiniteHtml(html, sectionId, productListId) {
    var temporaryDocument = new DOMParser().parseFromString(html, 'text/html');
    var fetchedSection = temporaryDocument.getElementById('shopify-section-' + sectionId) || temporaryDocument.querySelector('.shopify-section--main-collection') || temporaryDocument.body;
    var fetchedProductList = productListId ? temporaryDocument.getElementById(productListId) : null;

    if (!fetchedProductList && fetchedSection && fetchedSection.querySelector) {
      fetchedProductList = fetchedSection.querySelector('product-list');
    }

    if (!fetchedProductList) {
      fetchedProductList = temporaryDocument.querySelector('product-list');
    }

    var nextPager = fetchedSection && fetchedSection.querySelector ? fetchedSection.querySelector('[data-bup-collection-infinite]') : null;

    if (!nextPager) {
      nextPager = temporaryDocument.querySelector('[data-bup-collection-infinite]');
    }

    return {
      fetchedProductList: fetchedProductList,
      nextPager: nextPager
    };
  }

  function enhanceCollectionInfiniteProducts(scope) {
    try { ensureCardSuperdesk(scope); } catch (error) {}
    try { initializeProductCardSwatches(scope); } catch (error) {}
    try { hydrateFavorites(scope); } catch (error) {}
    try { scheduleCardRatingRowSync(scope); } catch (error) {}
  }

  function loadCollectionInfinitePage(pager) {
    if (!pager || pager.dataset.bupCollectionInfiniteLoading === 'true') return;

    var sectionId = pager.getAttribute('data-section-id');
    var productListId = pager.getAttribute('data-product-list-id');
    var nextUrl = pager.getAttribute('data-next-url');

    if (!sectionId || !productListId || !nextUrl) {
      stopCollectionInfiniteObserver(pager);
      pager.remove();
      return;
    }

    var requestUrl = new URL(nextUrl, window.location.origin);
    requestUrl.searchParams.set('section_id', sectionId);
    var fallbackUrl = new URL(nextUrl, window.location.origin);
    fallbackUrl.searchParams.delete('section_id');
    setCollectionInfiniteState(pager, true);

    requestCollectionInfiniteHtml(requestUrl)
      .then(function (html) {
        var parts = parseCollectionInfiniteHtml(html, sectionId, productListId);

        if (parts.fetchedProductList) return parts;

        return requestCollectionInfiniteHtml(fallbackUrl)
          .then(function (fallbackHtml) {
            return parseCollectionInfiniteHtml(fallbackHtml, sectionId, productListId);
          });
      })
      .then(function (parts) {
        if (!pager.isConnected) return;

        var fetchedProductList = parts.fetchedProductList;
        var nextPager = parts.nextPager;
        var currentSection = document.getElementById('shopify-section-' + sectionId) || pager.closest('.shopify-section');
        var currentProductList = document.getElementById(productListId);

        if (!currentProductList) {
          var currentCollectionMain = pager.closest('.collection__main');
          currentProductList = currentCollectionMain && currentCollectionMain.querySelector('product-list');
        }

        if (!fetchedProductList) {
          throw new Error('Collection response did not include the expected product list.');
        }

        if (!currentSection || !currentSection.contains(pager) || !currentProductList) {
          return;
        }

        Array.prototype.slice.call(fetchedProductList.children).forEach(function (child) {
          currentProductList.appendChild(document.importNode(child, true));
        });

        enhanceCollectionInfiniteProducts(currentProductList);

        if (nextPager && nextPager.getAttribute('data-next-url')) {
          pager.setAttribute('data-next-url', nextPager.getAttribute('data-next-url'));
          pager.dataset.bupCollectionInfiniteRetries = '0';
          setCollectionInfiniteState(pager, false);
          observeCollectionInfinitePager(pager);
        } else {
          stopCollectionInfiniteObserver(pager);
          pager.remove();
        }
      })
      .catch(function () {
        if (!pager.isConnected) return;

        var retries = Number(pager.dataset.bupCollectionInfiniteRetries || 0);
        pager.dataset.bupCollectionInfiniteRetries = String(retries + 1);
        setCollectionInfiniteState(pager, false);

        if (retries < 2) {
          window.setTimeout(function () {
            if (pager.isConnected) loadCollectionInfinitePage(pager);
          }, 700 * (retries + 1));
        } else {
          stopCollectionInfiniteObserver(pager);
          pager.remove();
        }
      });
  }

  function observeCollectionInfinitePager(pager) {
    stopCollectionInfiniteObserver(pager);

    var sentinel = pager.querySelector('[data-bup-collection-sentinel]');
    if (!sentinel) return;

    function checkPagerPosition() {
      if (!pager.isConnected) {
        stopCollectionInfiniteObserver(pager);
        return;
      }

      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      if (sentinel.getBoundingClientRect().top <= viewportHeight + 700) loadCollectionInfinitePage(pager);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadCollectionInfinitePage(pager);
        });
      }, { rootMargin: '700px 0px' });

      observer.observe(sentinel);
      pager._bupCollectionInfiniteObserver = observer;
      return;
    }

    var queued = false;
    var fallback = function () {
      if (queued) return;

      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        checkPagerPosition();
      });
    };

    pager._bupCollectionInfiniteFallback = fallback;
    window.addEventListener('scroll', fallback, { passive: true });
    window.addEventListener('resize', fallback);
    fallback();
  }

  function initializeCollectionInfinite(scope) {
    var root = scope && scope.nodeType === Node.ELEMENT_NODE ? scope : document;
    var pagers = [];

    if (root.matches && root.matches('[data-bup-collection-infinite]')) pagers.push(root);
    if (root.querySelectorAll) pagers = pagers.concat(Array.prototype.slice.call(root.querySelectorAll('[data-bup-collection-infinite]')));

    pagers.forEach(function (pager) {
      if (pager.dataset.bupCollectionInfiniteBound === 'true') return;

      pager.dataset.bupCollectionInfiniteBound = 'true';
      observeCollectionInfinitePager(pager);
    });
  }

  document.addEventListener('variant:add', function (event) {
    var panel = event.target.closest && event.target.closest('[data-bup-inline-quick-buy-panel]');
    if (panel) closeInlineQuickBuyPanel(panel);
  });

  document.addEventListener('cart:change', function (event) {
    var baseEvent = event.detail && event.detail.baseEvent;
    if (baseEvent !== 'variant:add' && baseEvent !== 'kombin:add') return;
    if (!document.getElementById('cart-drawer')) return;

    scheduleCartDrawerRefreshAfterAdd();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-bup-video-modal].is-open').forEach(closeVideo);
    document.querySelectorAll('[data-bup-weekly-offer].is-open').forEach(function (root) { setWeeklyOfferState(root, false); });
    document.querySelectorAll('[data-bup-inline-quick-buy-panel].is-open').forEach(function (panel) { closeInlineQuickBuyPanel(panel); });
    closeProductCardSwatchPanel();
    closeUpsellPicker();
  });

  document.addEventListener('DOMContentLoaded', function () {
    normalizeVideoEmbeds(document);
    bindProductVideoGalleries(document);
    bindProductGalleryZooms(document);
    initializeFavoritesDrawer(document);
    hydrateFavorites(document);
    hydrateCampaignCodes(document);
    startCampaignCountdowns(document);
    refreshProductAppMounts(document);
    observeQuickBuySuperdesk();
    initializeProductCardSwatches(document);
    hydrateCartUpsells(document);
    normalizeAccountNavigationTargets(document);
    hydrateKombinBundles(document);
    initializeFooterMenus(document);
    initializeHeaderDisclosures(document);
    initializeCollectionSizeFilters(document);
    initializeCollectionInfinite(document);
    initializeLiveMobileNavigation(document);
    initializeCartDrawerState(document);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        scheduleCardRatingRowSync(document);
      });
    }

    window.addEventListener('resize', function () {
      scheduleCardRatingRowSync(document);
    });

    if (window.MutationObserver) {
      var pendingMutationNodes = [];
      var pendingMutationFrame = null;
      var enhancementNodeSelector = [
        'product-gallery[data-bup-video-gallery]',
        'product-gallery[allow-zoom]',
        '[data-bup-kombin-bundle]',
        '.bup-product-card-swatches',
        '[data-bup-collection-size-filter]',
        '[data-bup-collection-infinite]',
        '[data-bup-cart-upsell]',
        '[data-bup-favorite-product]',
        '[data-bup-favorite-count]',
        '[data-bup-favorites-drawer]',
        '.bup-live-mobile-sidebar',
        'cart-drawer'
      ].join(',');

      function containsEnhancementNode(node) {
        return node.matches(enhancementNodeSelector) || node.querySelector(enhancementNodeSelector);
      }

      function initializeAddedEnhancementNodes(nodes) {
        nodes.forEach(function (node) {
          normalizeAccountNavigationTargets(node);

          if (!containsEnhancementNode(node)) return;

          bindProductVideoGalleries(node);
          bindProductGalleryZooms(node);
          hydrateKombinBundles(node);

          if (node.matches('.bup-product-card-swatches') || node.querySelector('.bup-product-card-swatches')) {
            initializeProductCardSwatches(node);
          }

          if (node.matches('[data-bup-collection-infinite]') || node.querySelector('[data-bup-collection-infinite]')) {
            initializeCollectionInfinite(node);
          }

          if (node.matches('[data-bup-collection-size-filter]') || node.querySelector('[data-bup-collection-size-filter]')) {
            initializeCollectionSizeFilters(node);
          }

          if (node.matches('[data-bup-cart-upsell]') || node.querySelector('[data-bup-cart-upsell]')) {
            hydrateCartUpsells(node);
          }

          if (node.matches('[data-bup-favorite-product], [data-bup-favorite-count], [data-bup-favorites-drawer]') || node.querySelector('[data-bup-favorite-product], [data-bup-favorite-count], [data-bup-favorites-drawer]')) {
            initializeFavoritesDrawer(node);
            hydrateFavorites(node);
          }

          if (node.matches('.bup-live-mobile-sidebar') || node.querySelector('.bup-live-mobile-sidebar')) {
            initializeLiveMobileNavigation(node);
          }

          if (node.matches('cart-drawer') || node.querySelector('cart-drawer')) {
            initializeCartDrawerState(node);
          }
        });
      }

      new MutationObserver(function (records) {
        records.forEach(function (record) {
          record.addedNodes.forEach(function (node) {
            if (node.nodeType === Node.ELEMENT_NODE) pendingMutationNodes.push(node);
          });
        });

        if (pendingMutationFrame || pendingMutationNodes.length === 0) return;

        pendingMutationFrame = window.requestAnimationFrame(function () {
          var nodes = Array.from(new Set(pendingMutationNodes)).filter(function (node) { return node.isConnected; });
          pendingMutationNodes = [];
          pendingMutationFrame = null;
          initializeAddedEnhancementNodes(nodes);
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  });
  document.addEventListener('shopify:section:load', function (event) {
    normalizeVideoEmbeds(event.target);
    bindProductVideoGalleries(event.target);
    bindProductGalleryZooms(event.target);
    initializeFavoritesDrawer(event.target);
    hydrateFavorites(event.target);
    hydrateCampaignCodes(event.target);
    startCampaignCountdowns(event.target);
    refreshProductAppMounts(event.target);
    scanQuickBuySuperdesk(event.target);
    ensureCardSuperdesk(event.target);
    initializeProductCardSwatches(event.target);
    hydrateCartUpsells(event.target);
    normalizeAccountNavigationTargets(event.target);
    hydrateKombinBundles(event.target);
    initializeFooterMenus(event.target);
    initializeHeaderDisclosures(event.target);
    initializeCollectionSizeFilters(event.target);
    initializeCollectionInfinite(event.target);
    initializeLiveMobileNavigation(event.target);
    initializeCartDrawerState(event.target);
  });
  document.addEventListener('theme:loading:end', function () {
    window.requestAnimationFrame(function () {
      initializeCollectionSizeFilters(document);
      initializeCollectionInfinite(document);
      ensureCardSuperdesk(document);
      initializeProductCardSwatches(document);
    });
  });
  document.addEventListener('aisearchOpen', function () {
    window.requestAnimationFrame(function () {
      document.querySelectorAll('header-search[open]').forEach(function (headerSearch) {
        if (typeof headerSearch.hide === 'function') {
          headerSearch.hide();
        } else {
          headerSearch.removeAttribute('open');
        }
      });
    });
  });
  document.addEventListener('cart-drawer:refreshed', function (event) {
    cartDrawerRefreshVersion += 1;
    if (pendingCartDrawerRefresh) {
      window.clearTimeout(pendingCartDrawerRefresh);
      pendingCartDrawerRefresh = null;
    }

    hydrateFavorites(event.target);
    ensureCardSuperdesk(event.target);
    refreshCartUpsells(event.target);
  });
  window.addEventListener('storage', function (event) {
    if (event.key === favKey || event.key === legacyFavKey) hydrateFavorites(document);
  });
})();
